import * as React from "react";
const WeddingWebsiteSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-wedding"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-wedding:not(.animated) .animable {opacity: 0;}svg#freepik_stories-wedding.animated #freepik--background-complete--inject-64 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-wedding.animated #freepik--Floor--inject-64 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-wedding.animated #freepik--Hearts--inject-64 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-wedding.animated #freepik--Characters--inject-64 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        "
      }
    </style>
    <g
      id="freepik--background-complete--inject-64"
      className="animable"
      style={{
        transformOrigin: "263.885px 254.503px",
      }}
    >
      <path
        d="M179.46,262a18.73,18.73,0,0,0-3.14-10.81A18,18,0,0,0,168,244a14.52,14.52,0,0,0-17,4.85,14.52,14.52,0,0,0-14.38-9.31,18,18,0,0,0-10.18,4.22,18.7,18.7,0,0,0-6.36,9.28,22.78,22.78,0,0,0,.57,14.3c1.89,4.67,5.48,8.78,9.33,12,6.47,5.46,15,12.39,15,12.39s8.94-4.69,16.8-7.86c4.67-1.88,9.37-4.66,12.62-8.51A22.87,22.87,0,0,0,179.46,262Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "149.33px 265.623px",
        }}
        id="elkcz5cw9o3k"
        className="animable"
      />
      <path
        d="M183.46,170.69a11,11,0,0,0-3.13-5.82,10.57,10.57,0,0,0-5.68-3.11,8.56,8.56,0,0,0-9.16,4.86,8.45,8.45,0,0,0-2.68-2.61,8.68,8.68,0,0,0-6.73-1,10.57,10.57,0,0,0-5.33,3.67,11,11,0,0,0-2.52,6.11,13.43,13.43,0,0,0,2.09,8.15,18.94,18.94,0,0,0,6.83,5.78c4.39,2.35,10.16,5.27,10.16,5.27s4.56-3.78,8.7-6.57a18.9,18.9,0,0,0,6.2-6.44A13.34,13.34,0,0,0,183.46,170.69Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "165.926px 176.818px",
        }}
        id="el7np8vulpu4p"
        className="animable"
      />
      <path
        d="M102.73,208.06a8.45,8.45,0,0,0-3.33-3.77A8.09,8.09,0,0,0,94.66,203a6.48,6.48,0,0,0-5.92,5.19,6.52,6.52,0,0,0-7.58-1,8.09,8.09,0,0,0-3.3,3.64,8.37,8.37,0,0,0-.8,5,10.22,10.22,0,0,0,3,5.66,14.39,14.39,0,0,0,6,3.08c3.66,1,8.44,2.13,8.44,2.13s2.71-3.59,5.28-6.37a14.39,14.39,0,0,0,3.46-5.84A10.14,10.14,0,0,0,102.73,208.06Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.2547px 214.846px",
        }}
        id="elpemiy5aslvo"
        className="animable"
      />
      <path
        d="M450.8,336.87a6.63,6.63,0,0,0-1.1-3.8,6.37,6.37,0,0,0-2.93-2.53,5.19,5.19,0,0,0-4.07.14,5.13,5.13,0,0,0-1.9,1.56,5.1,5.1,0,0,0-1.24-1.87,5.22,5.22,0,0,0-3.81-1.41,6.3,6.3,0,0,0-3.58,1.48,6.55,6.55,0,0,0-2.24,3.26,8,8,0,0,0,.19,5A11.3,11.3,0,0,0,433.4,343c2.27,1.92,5.28,4.36,5.28,4.36s3.14-1.64,5.9-2.75a11.3,11.3,0,0,0,4.44-3A8,8,0,0,0,450.8,336.87Z"
        style={{
          fill: "#213E60",
          transformOrigin: "440.21px 338.157px",
        }}
        id="elzvjc6ajlj"
        className="animable"
      />
    </g>
    <g
      id="freepik--Floor--inject-64"
      className="animable"
      style={{
        transformOrigin: "263.36px 456.44px",
      }}
    >
      <path
        d="M482.86,456.44c0,.15-98.28.26-219.49.26s-219.51-.11-219.51-.26,98.26-.26,219.51-.26S482.86,456.3,482.86,456.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "263.36px 456.44px",
        }}
        id="elgumdk9vfs1j"
        className="animable"
      />
    </g>
    <g
      id="freepik--Hearts--inject-64"
      className="animable"
      style={{
        transformOrigin: "360.535px 178.185px",
      }}
    >
      <path
        d="M431.09,302.57a5.46,5.46,0,0,0-2-2.59,5.27,5.27,0,0,0-3-1.05,4.25,4.25,0,0,0-4.08,3.15,4.25,4.25,0,0,0-4.9-1,5.24,5.24,0,0,0-2.3,2.24,5.46,5.46,0,0,0-.72,3.2,6.62,6.62,0,0,0,1.7,3.81,9.42,9.42,0,0,0,3.83,2.26c2.34.78,5.42,1.73,5.42,1.73s1.91-2.24,3.7-3.95a9.3,9.3,0,0,0,2.49-3.67A6.61,6.61,0,0,0,431.09,302.57Z"
        style={{
          fill: "#213E60",
          transformOrigin: "422.783px 306.625px",
        }}
        id="elpwx5pqu1mri"
        className="animable"
      />
      <path
        d="M328.2,50.27a12.36,12.36,0,0,0-4.57-5.85,11.86,11.86,0,0,0-6.87-2.37,9.6,9.6,0,0,0-9.22,7.13,9.44,9.44,0,0,0-3.46-2.39,9.72,9.72,0,0,0-7.63.21,11.84,11.84,0,0,0-5.2,5.07,12.27,12.27,0,0,0-1.63,7.24,15.1,15.1,0,0,0,3.85,8.62,21.24,21.24,0,0,0,8.66,5.1c5.31,1.77,12.25,3.91,12.25,3.91s4.33-5.06,8.37-8.92a21.23,21.23,0,0,0,5.65-8.31A15.09,15.09,0,0,0,328.2,50.27Z"
        style={{
          fill: "#213E60",
          transformOrigin: "309.318px 59.495px",
        }}
        id="elmoab2pnopos"
        className="animable"
      />
    </g>
    <g
      id="freepik--Characters--inject-64"
      className="animable animator-active"
      style={{
        transformOrigin: "215.997px 286.54px",
      }}
    >
      <path
        d="M313.75,440.39l-.71,19s-19.34,4.07-19.81,7.57l36.56,4.28,2.32-29.53Z"
        style={{
          fill: "#213E60",
          transformOrigin: "312.67px 455.815px",
        }}
        id="elvcxmy8wd38p"
        className="animable"
      />
      <path
        d="M324.52,458.62a1.49,1.49,0,0,1,.91,1.79,1.45,1.45,0,0,1-1.76.92,1.6,1.6,0,0,1-1-1.9,1.52,1.52,0,0,1,2-.76"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "324.052px 459.962px",
        }}
        id="ellpbj22d3a5i"
        className="animable"
      />
      <path
        d="M329.79,471.22l.23-2.94-34.7-3.39s-2.11,1-2.17,2.13Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "311.585px 468.055px",
        }}
        id="el9t6p29srtmk"
        className="animable"
      />
      <path
        d="M312.46,459.14c0,.18.88.33,1.72,1s1.26,1.43,1.43,1.38,0-1.12-1.05-1.88S312.43,459,312.46,459.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "314.063px 460.279px",
        }}
        id="el3mmlhwckv5u"
        className="animable"
      />
      <path
        d="M308.49,460.45c-.06.18.7.54,1.25,1.34s.67,1.62.85,1.63.37-1-.34-2S308.5,460.28,308.49,460.45Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "309.621px 461.904px",
        }}
        id="eloyjsf5sajml"
        className="animable"
      />
      <path
        d="M306,464.91c.16,0,.47-.83.08-1.85s-1.2-1.47-1.28-1.32.39.7.7,1.54S305.78,464.88,306,464.91Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "305.53px 463.311px",
        }}
        id="el92mq0zn6g3h"
        className="animable"
      />
      <path
        d="M313.1,454.84c.06.16.91,0,1.91.12s1.78.52,1.89.38-.61-.85-1.8-1S313,454.69,313.1,454.84Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "315.002px 454.841px",
        }}
        id="elbng890sd53"
        className="animable"
      />
      <path
        d="M313.31,451a3.5,3.5,0,0,0,1.85.12,7.94,7.94,0,0,0,2-.45,7.39,7.39,0,0,0,1.09-.48,2.3,2.3,0,0,0,.59-.39.79.79,0,0,0,.15-.95,1,1,0,0,0-.75-.47,2.2,2.2,0,0,0-.7.05,5.89,5.89,0,0,0-1.17.31,6.44,6.44,0,0,0-1.78,1c-.91.73-1.25,1.38-1.19,1.42s.53-.47,1.44-1a7.36,7.36,0,0,1,1.71-.81,7,7,0,0,1,1.09-.25c.39-.07.72-.05.81.13s0,.1-.06.2a1.53,1.53,0,0,1-.43.29,10.34,10.34,0,0,1-1,.49,10.24,10.24,0,0,1-1.83.55A11.94,11.94,0,0,0,313.31,451Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "316.198px 449.782px",
        }}
        id="eloxvxslqnvrh"
        className="animable"
      />
      <path
        d="M313.53,451.28c.06,0,.46-.58.62-1.74a6.22,6.22,0,0,0-.49-3.19,1.54,1.54,0,0,0-1.11-1,.86.86,0,0,0-.81.46,2.17,2.17,0,0,0-.23.66,4.05,4.05,0,0,0-.1,1.24,4.25,4.25,0,0,0,.65,2c.65,1,1.38,1.27,1.4,1.21s-.53-.48-1-1.43a4.39,4.39,0,0,1-.45-1.78,3.9,3.9,0,0,1,.11-1.06c.09-.38.26-.69.4-.64s.47.33.6.65a6.84,6.84,0,0,1,.38,1,6.53,6.53,0,0,1,.22,1.87C313.68,450.59,313.43,451.25,313.53,451.28Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "312.793px 448.314px",
        }}
        id="el26xmrj85opa"
        className="animable"
      />
      <path
        d="M396.18,436.18l4.73,23.36,9.07,17.4a2.45,2.45,0,0,1-1.18,3.37h0a2.47,2.47,0,0,1-2.23-.14c-4.32-2.6-20.16-12.24-20.41-14-.29-2-6.63-24.31-6.63-24.31Z"
        style={{
          fill: "#213E60",
          transformOrigin: "394.893px 458.346px",
        }}
        id="elot30no1p4d"
        className="animable"
      />
      <path
        d="M408.8,480.31l-23-15.68.23,1a3.63,3.63,0,0,0,1.37,2.13c1.87,1.4,7.12,5.15,19.1,12.43a2.44,2.44,0,0,0,2.3.13Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "397.3px 472.589px",
        }}
        id="elli8zkmx65s8"
        className="animable"
      />
      <path
        d="M388.91,457.73a1.48,1.48,0,0,1,.82,1.79,1.41,1.41,0,0,1-1.77.83,1.55,1.55,0,0,1-.86-1.9,1.47,1.47,0,0,1,1.94-.66"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "388.41px 459.036px",
        }}
        id="el7r2c53poh8g"
        className="animable"
      />
      <path
        d="M401.18,471.35a7.74,7.74,0,0,1,1.63-2.27,7.45,7.45,0,0,1,2.56-1.11c0-.07-.33-.18-.89-.13a3.74,3.74,0,0,0-2,.84,3.79,3.79,0,0,0-1.24,1.78C401.08,471,401.12,471.35,401.18,471.35Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "403.249px 469.589px",
        }}
        id="eli0nfzm38md"
        className="animable"
      />
      <path
        d="M403.54,474.09c.14.08.71-.85,1.84-1.46a17.52,17.52,0,0,1,2.2-.81,2.7,2.7,0,0,0-2.46.35C403.84,472.88,403.41,474.06,403.54,474.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "405.549px 472.882px",
        }}
        id="elpvbvr2ulsv"
        className="animable"
      />
      <path
        d="M397.2,468.06a24.48,24.48,0,0,1,2.67-2.45,25.27,25.27,0,0,1,3.27-1.59,5.44,5.44,0,0,0-3.56,1.16A5.37,5.37,0,0,0,397.2,468.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "400.17px 466.038px",
        }}
        id="elh2thk5qpkoh"
        className="animable"
      />
      <path
        d="M395.16,461.08c.1.13,1.26-.7,2.92-1.14s3.07-.34,3.09-.49a6.1,6.1,0,0,0-6,1.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "398.165px 460.162px",
        }}
        id="eljm6tpmtl2p"
        className="animable"
      />
      <path
        d="M393.6,454.26a12,12,0,0,1,3-1.27,11.45,11.45,0,0,1,3.26.08c0-.06-.29-.29-.9-.48a5.34,5.34,0,0,0-4.7.89C393.76,453.88,393.55,454.22,393.6,454.26Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "396.726px 453.323px",
        }}
        id="eleg5lfx0j42r"
        className="animable"
      />
      <path
        d="M396.27,451.7a2.26,2.26,0,0,0-.17-.88,6.21,6.21,0,0,0-1.22-2.15,2.82,2.82,0,0,0-1.46-1,1,1,0,0,0-1,.46,1.65,1.65,0,0,0-.13,1.13,3.46,3.46,0,0,0,3.66,2.45,4,4,0,0,0,3.37-2.91,1.41,1.41,0,0,0-.19-1.15,1,1,0,0,0-1.1-.27,3.53,3.53,0,0,0-1.35,1.14,7.12,7.12,0,0,0-1.17,2.17,2.18,2.18,0,0,0-.18.88,11.53,11.53,0,0,1,1.64-2.81,3.15,3.15,0,0,1,1.2-1,.51.51,0,0,1,.6.15,1,1,0,0,1,.08.76,3.59,3.59,0,0,1-2.95,2.49,3,3,0,0,1-3.14-2,1.18,1.18,0,0,1,.06-.8.52.52,0,0,1,.56-.26,2.49,2.49,0,0,1,1.25.85A9.33,9.33,0,0,1,396.27,451.7Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "395.806px 449.521px",
        }}
        id="el4l8da9y7lbq"
        className="animable"
      />
      <path
        d="M391.31,277.83c.24,0,11.83,177.39,11.83,177.39l-23.74.51-13.6-96-7.55-73.39L347.4,355.47l-12.81,98.28-24-4.61L323,273.83l33.47-19.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "356.865px 355.035px",
        }}
        id="el4bpoha49bak"
        className="animable"
      />
      <path
        d="M368.44,152.39,346,151.07c-.2-2.61-.23-12.76-.23-12.76s-9.36-1.25-9.68-10.58.84-30.81.84-30.81h0a32.5,32.5,0,0,1,32.7,3.4l1.4,1Z"
        style={{
          fill: "rgb(183, 136, 118)",
          transformOrigin: "353.532px 123.198px",
        }}
        id="elucixk427r49"
        className="animable"
      />
      <path
        d="M345.72,138.18a21.72,21.72,0,0,0,12.09-3.72s-2.73,6.78-12.06,6.14Z"
        style={{
          fill: "rgb(170, 101, 80)",
          transformOrigin: "351.765px 137.551px",
        }}
        id="elpqrirybzklg"
        className="animable"
      />
      <path
        d="M370.05,111.05c.16-.07,6.38-2,6.31,4.36s-6.47,5-6.48,4.81S370.05,111.05,370.05,111.05Z"
        style={{
          fill: "rgb(183, 136, 118)",
          transformOrigin: "373.12px 115.596px",
        }}
        id="elm1ti58lh5uo"
        className="animable"
      />
      <path
        d="M371.86,117.82s.11.08.3.17a1.09,1.09,0,0,0,.83,0,2.75,2.75,0,0,0,1.3-2.46,3.78,3.78,0,0,0-.3-1.6,1.32,1.32,0,0,0-.82-.86.57.57,0,0,0-.66.3c-.09.18-.05.31-.09.32s-.13-.11-.08-.38a.74.74,0,0,1,.26-.39.79.79,0,0,1,.61-.16,1.59,1.59,0,0,1,1.16,1,3.85,3.85,0,0,1,.36,1.79,2.88,2.88,0,0,1-1.65,2.74,1.19,1.19,0,0,1-1-.18C371.87,118,371.84,117.84,371.86,117.82Z"
        style={{
          fill: "rgb(170, 101, 80)",
          transformOrigin: "373.294px 115.541px",
        }}
        id="elqqzsr4dmyt"
        className="animable"
      />
      <path
        d="M339.1,112.16a1.33,1.33,0,0,0,1.32,1.32,1.28,1.28,0,0,0,1.35-1.23,1.35,1.35,0,0,0-1.32-1.32A1.28,1.28,0,0,0,339.1,112.16Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "340.435px 112.205px",
        }}
        id="el74n05degw49"
        className="animable"
      />
      <path
        d="M338.94,110c.17.17,1.17-.6,2.6-.63s2.5.67,2.65.49-.1-.39-.56-.71a3.64,3.64,0,0,0-2.13-.61,3.45,3.45,0,0,0-2.06.72C339,109.62,338.86,109.94,338.94,110Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "341.576px 109.281px",
        }}
        id="el9kqrvmejxou"
        className="animable"
      />
      <path
        d="M353.06,111.87a1.32,1.32,0,0,0,1.31,1.31,1.27,1.27,0,0,0,1.35-1.23,1.34,1.34,0,0,0-1.31-1.32A1.28,1.28,0,0,0,353.06,111.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "354.39px 111.905px",
        }}
        id="elay3ci4bsqzd"
        className="animable"
      />
      <path
        d="M353.05,110c.17.17,1.17-.6,2.6-.62s2.5.67,2.65.49-.1-.39-.56-.72a3.64,3.64,0,0,0-2.13-.6,3.51,3.51,0,0,0-2.06.71C353.11,109.59,353,109.91,353.05,110Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.691px 109.286px",
        }}
        id="elg19ki3anq9c"
        className="animable"
      />
      <path
        d="M348.07,120.74a9,9,0,0,0-2.34-.38c-.36,0-.71-.09-.78-.34a1.87,1.87,0,0,1,.22-1.09c.33-.89.67-1.83,1-2.81,1.42-4,2.43-7.3,2.27-7.35s-1.44,3.14-2.86,7.15l-1,2.82a2.13,2.13,0,0,0-.16,1.45.94.94,0,0,0,.62.52,2,2,0,0,0,.62.07A9.47,9.47,0,0,0,348.07,120.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "346.408px 114.804px",
        }}
        id="elkqrq3yabt7"
        className="animable"
      />
      <path
        d="M352.32,121.64c-.24,0-.21,1.55-1.52,2.68s-3,1-3,1.22.37.29,1.07.29a3.88,3.88,0,0,0,2.49-.92,3.39,3.39,0,0,0,1.17-2.25C352.6,122,352.42,121.63,352.32,121.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "350.173px 123.735px",
        }}
        id="el2hj79eejh19"
        className="animable"
      />
      <path
        d="M352.56,104.37c.15.39,1.58.17,3.27.34s3.06.59,3.27.24c.1-.17-.15-.53-.7-.9a5.56,5.56,0,0,0-2.44-.79,5.5,5.5,0,0,0-2.55.35C352.8,103.87,352.5,104.18,352.56,104.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.837px 104.159px",
        }}
        id="elfg2k7nd67cq"
        className="animable"
      />
      <path
        d="M339.38,105.85c.26.32,1.24,0,2.43-.08s2.2.18,2.42-.17c.1-.17-.06-.49-.51-.79a3.54,3.54,0,0,0-3.91.2C339.4,105.36,339.27,105.7,339.38,105.85Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "341.801px 105.153px",
        }}
        id="elladim6xrj4"
        className="animable"
      />
      <path
        d="M332.22,91.12a3.42,3.42,0,0,1,1.21-3.1,2.44,2.44,0,0,1,3.17.17A2.86,2.86,0,0,1,339,84.67c1.52-.12,2.84,1,4.32,1.37a6.93,6.93,0,0,0,4.35-.6c1.37-.58,2.64-1.38,4-1.92A11.94,11.94,0,0,1,367.1,90.2a5.32,5.32,0,0,1,5.67,2,8.65,8.65,0,0,1,1.46,6.1,19.21,19.21,0,0,1-1,4.21c0,.12,0,.24,0,.36,0,5.14-.44,11.18-2.63,11.26-3.81.14-3.06-7.07-3.06-7.07-4.72-1.71-3.13-8.77-4.32-9.81s-3.7-3.46-13.4,1.76a19,19,0,0,1-11.61,1.51l-.24,0H338s-.05,0-.08,0a8.71,8.71,0,0,1-2.54-1,4.93,4.93,0,0,1-2.12-2.26,2.7,2.7,0,0,1,.47-2.93A5.94,5.94,0,0,1,332.22,91.12Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "353.249px 98.4164px",
        }}
        id="elk7jxz75gtpf"
        className="animable"
      />
      <path
        d="M392.14,156.31s10.6,3.12,15.95,23.8C412,195.29,424.91,225,422.43,229.9c-3.08,6.08-46.21,7.77-46.21,7.77l.61-15.68,19.69-5.59-12-30.31S382.76,158.08,392.14,156.31Z"
        style={{
          fill: "#213E60",
          transformOrigin: "399.482px 196.99px",
        }}
        id="el25z7surk74z"
        className="animable"
      />
      <path
        d="M390,195.15c0,1.59-4,33.37-4,33.37l10.53,51.29-36.47,2.72-4.54-22.13L351,282.72l-33-7.29,7.67-35.31L321.44,195l2.72-37.6,13.39-4.89,7.91-8.05L355.78,151l13.73-8.63,4.52,5.91,18.11,8C394,159.55,390,195.15,390,195.15Z"
        style={{
          fill: "#213E60",
          transformOrigin: "357.265px 212.545px",
        }}
        id="elceb0y4psih"
        className="animable"
      />
      <path
        d="M369.51,142.38l.66,10-18.1,51.49-8.84-50,2.31-9.69h0L355.78,151Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "356.7px 173.125px",
        }}
        id="eluaihc1hr3jr"
        className="animable"
      />
      <path
        d="M324.16,157.42s-9,7.62-12,16.49-7.83,20.57-7.83,20.57l17.14-.36Z"
        style={{
          fill: "#213E60",
          transformOrigin: "314.245px 175.95px",
        }}
        id="el49pz0g288vn"
        className="animable"
      />
      <path
        d="M352.55,205.77a3.86,3.86,0,0,0,.45-.56q.45-.65,1.2-1.68l4.33-6.21,14.11-20.61,2.33-3.43.11-.16L375,173,371,167.53l-.06.37,8.34-6.51.13-.1-.06-.15-3.84-9.39c-.46-1.07-.82-1.93-1.09-2.57a4.63,4.63,0,0,0-.43-.89,6,6,0,0,0,.31.93c.24.66.57,1.53,1,2.62L379,161.3l.07-.26-8.39,6.44-.2.15.15.21,3.91,5.44V173l-2.33,3.43-14,20.7L354,203.41l-1.12,1.73A2.83,2.83,0,0,0,352.55,205.77Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "365.98px 177.03px",
        }}
        id="el2bfepvo8ove"
        className="animable"
      />
      <path
        d="M355.35,259a2.39,2.39,0,0,0,0-.56c0-.43,0-.95-.06-1.59-.07-1.46-.17-3.43-.29-5.84-.27-5-.64-11.77-1.06-19.25s-.74-14.25-1-19.26c-.11-2.4-.21-4.37-.28-5.83,0-.64-.07-1.16-.09-1.59a3.06,3.06,0,0,0-.07-.55,1.84,1.84,0,0,0,0,.55c0,.43,0,.95,0,1.59,0,1.38,0,3.38.11,5.85.13,4.93.42,11.75.84,19.27s.86,14.33,1.22,19.25c.19,2.4.35,4.37.47,5.83l.15,1.58A2.3,2.3,0,0,0,355.35,259Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "353.923px 231.765px",
        }}
        id="elv7hglfognaa"
        className="animable"
      />
      <path
        d="M351.71,204.29a2.6,2.6,0,0,0-.19-.57l-.67-1.62c-.64-1.46-1.5-3.46-2.56-5.9-2.24-5-5.27-11.84-8.63-19.38l-2.06-4.57,0,.28,4.36-5.44.14-.18-.16-.16-6.62-6.56.05.2c.8-2.51,1.46-4.56,1.94-6.06.21-.67.37-1.22.51-1.66a2.5,2.5,0,0,0,.13-.59,3.63,3.63,0,0,0-.24.56q-.24.63-.6,1.62c-.52,1.49-1.24,3.52-2.11,6l0,.11.09.09,6.53,6.64,0-.34-4.38,5.41-.11.13.07.16,2,4.58c3.42,7.51,6.51,14.3,8.78,19.31l2.72,5.83.76,1.57A2.71,2.71,0,0,0,351.71,204.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "343.355px 178.185px",
        }}
        id="elgkz3yjyllx8"
        className="animable"
      />
      <g id="elpwl2zzg1z1">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "366.675px 182.51px",
          }}
          className="animable"
          id="elmnxa3sw3dk"
        >
          <polygon
            points="379.18 161.22 373.66 167.66 377.72 174.59 354.17 203.8 374.74 173.12 370.82 167.69 379.18 161.22"
            id="elumunhggu46p"
            className="animable"
            style={{
              transformOrigin: "366.675px 182.51px",
            }}
          />
        </g>
      </g>
      <g id="elooum7w7slk">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "344.11px 187.66px",
          }}
          className="animable"
          id="el6qpkc5uyrwf"
        >
          <polygon
            points="351.12 202.96 337.1 176.84 337.35 172.36 351.12 202.96"
            id="elvhlrjypw6gd"
            className="animable"
            style={{
              transformOrigin: "344.11px 187.66px",
            }}
          />
        </g>
      </g>
      <path
        d="M392.6,161.52s-.28.14-.72.49a14,14,0,0,0-1.76,1.61,21.67,21.67,0,0,0-5.9,14.25,14.29,14.29,0,0,0,.11,2.38,2.42,2.42,0,0,0,.17.85c.09,0,0-1.24.11-3.21a24.06,24.06,0,0,1,5.8-14C391.71,162.39,392.67,161.6,392.6,161.52Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "388.407px 171.31px",
        }}
        id="elncpw9r1ccg8"
        className="animable"
      />
      <path
        d="M322.62,188.8c.15,0,.55-5.83.88-13s.48-13.05.33-13.06-.55,5.83-.88,13S322.47,188.79,322.62,188.8Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "323.225px 175.77px",
        }}
        id="elmq3p0gq7fdo"
        className="animable"
      />
      <path
        d="M343.3,154a4.22,4.22,0,0,0,.58.63c.4.39,1,1,1.76,1.65a47.54,47.54,0,0,0,6.83,5.32l.35.23v-.43a17.68,17.68,0,0,1,.74-5.7,15.75,15.75,0,0,1,1.32-2.87c.28-.47.58-.93.9-1.37l.12-.17.07-.09v0h0l-.35.09h0l0,0a1.15,1.15,0,0,1,.24.25,3.83,3.83,0,0,1,.43.67,19.65,19.65,0,0,1,1.45,4.84c.33,1.62.62,3.18.87,4.66l.07.44.34-.28,8-6.67,2.25-1.93a4.57,4.57,0,0,0,.77-.74,6.07,6.07,0,0,0-.87.61l-2.35,1.82-8.13,6.51.41.16c-.24-1.49-.51-3.06-.84-4.69a20.07,20.07,0,0,0-1.48-5,5.17,5.17,0,0,0-.49-.76,2.31,2.31,0,0,0-.35-.35l-.07,0,0,0-.35.08h0l0,0-.06.09-.13.17c-.33.46-.64.94-.92,1.42a15.32,15.32,0,0,0-1.36,3,17.85,17.85,0,0,0-.71,5.87l.37-.2a54.71,54.71,0,0,1-6.89-5.13L344,154.52A3.54,3.54,0,0,0,343.3,154Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "356.67px 156.49px",
        }}
        id="el0b7x2wd72fyi"
        className="animable"
      />
      <path
        d="M352.52,203.36c.16,0,1-11.63,1.91-26s1.51-26,1.36-26-1,11.63-1.91,26S352.37,203.35,352.52,203.36Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "354.155px 177.36px",
        }}
        id="elaqnzx7f47wr"
        className="animable"
      />
      <g id="el26ouvir099b">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "387.895px 202.116px",
          }}
          className="animable"
          id="el3o61ick25d7"
        >
          <path
            d="M386.05,189.33s1,26.46,1.69,25.55c0,0,2-15.57,2-15.57Z"
            id="elflecuipp5g"
            className="animable"
            style={{
              transformOrigin: "387.895px 202.116px",
            }}
          />
        </g>
      </g>
      <path
        d="M364,152.93a2.44,2.44,0,0,0-1.34-1.57,2.47,2.47,0,0,0-2.06.66,14.69,14.69,0,0,0-2.84,2.84,2.33,2.33,0,0,0-.59-.39,2.58,2.58,0,0,0-2.52.19,2.73,2.73,0,0,0-.5.46,10.9,10.9,0,0,0-4-3.85,2.68,2.68,0,0,0-1.93-.41c-1.08.29-1.48,1.6-1.56,2.72a13.76,13.76,0,0,0,1,6.12,1.91,1.91,0,0,0,3.41.9,15,15,0,0,0,2.9-2.9,2.31,2.31,0,0,0,1.4,1.14,1.92,1.92,0,0,0,1.43-.18,2.47,2.47,0,0,0,.84-1,10.84,10.84,0,0,0,3.92,3.66,2.71,2.71,0,0,0,1.92.42c1.08-.29,1.48-1.61,1.56-2.72A13.76,13.76,0,0,0,364,152.93Z"
        style={{
          fill: "#213E60",
          transformOrigin: "355.847px 156.298px",
        }}
        id="elxfkrm1s9z8s"
        className="animable"
      />
      <path
        d="M356.79,158.59s-.29.37-1,.45a2.37,2.37,0,0,1-2.5-2.79,2.33,2.33,0,0,1,.55-1.1c.48-.52.94-.58,1-.52s-.33.25-.67.75a2.09,2.09,0,0,0,1.65,3.29C356.39,158.7,356.76,158.51,356.79,158.59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.021px 156.829px",
        }}
        id="elbw3w59qs2n6"
        className="animable"
      />
      <path
        d="M356.8,158.74c-.07,0,.06-.31.08-.75a2.67,2.67,0,0,0-.46-1.6c-.79-1.1-2-1.56-1.87-1.72s.33,0,.78.19a3.75,3.75,0,0,1,1.52,1.24,2.54,2.54,0,0,1,.4,2C357.11,158.56,356.85,158.78,356.8,158.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.925px 156.675px",
        }}
        id="elch21rx2orw"
        className="animable"
      />
      <path
        d="M357.69,155c.05,0,.26.12.45.49a2.38,2.38,0,0,1,.15,1.59,2.3,2.3,0,0,1-.92,1.3c-.35.23-.61.26-.63.2s.77-.61,1-1.64S357.56,155.09,357.69,155Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "357.551px 156.803px",
        }}
        id="elry66phvt01s"
        className="animable"
      />
      <path
        d="M361.22,154.54c0,.15-.73.35-1.54.81s-1.37,1-1.49.91.31-.84,1.23-1.36S361.22,154.41,361.22,154.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "359.695px 155.365px",
        }}
        id="elvkfcug5lhb"
        className="animable"
      />
      <path
        d="M361.16,157.42c-.09.12-.71-.17-1.51-.39s-1.47-.31-1.48-.46.74-.29,1.63,0S361.24,157.31,361.16,157.42Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "359.669px 156.925px",
        }}
        id="el6fnc7rbm7ba"
        className="animable"
      />
      <path
        d="M349.81,154.92c0-.14,1-.25,2.1.2s1.76,1.21,1.66,1.3-.84-.42-1.85-.82S349.81,155.07,349.81,154.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "351.695px 155.614px",
        }}
        id="el23emkqpy4ct"
        className="animable"
      />
      <path
        d="M349.87,157.74c-.1-.11.51-.73,1.52-1s1.85-.1,1.83,0-.79.19-1.69.46S350,157.86,349.87,157.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "351.54px 157.178px",
        }}
        id="elz1jieh4oy4q"
        className="animable"
      />
      <path
        d="M366.67,195.34s4.22-10.41,6.47-10.5,4.34,10.5,4.34,10.5Z"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "372.075px 190.09px",
        }}
        id="elojqf8yg78h"
        className="animable"
      />
      <rect
        x={364.88}
        y={194.64}
        width={13.44}
        height={2.35}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "371.6px 195.815px",
        }}
        id="elr979rnr50a"
        className="animable"
      />
      <path
        d="M415.83,233.21a5.23,5.23,0,0,1-.7.26c-.47.15-1.16.4-2.08.65a74.79,74.79,0,0,1-7.93,1.66,207,207,0,0,1-27.64,2.09h-.25v-.26c0-3.83,0-7.89,0-12.07v-3.7l.19-.05,19-5.61-.14.31c-3.19-7.55-5.49-14-7.25-18.5-.87-2.21-1.56-4-2-5.21l-.55-1.38a2.31,2.31,0,0,1-.16-.48,3.14,3.14,0,0,1,.23.45l.61,1.35c.52,1.19,1.26,2.94,2.16,5.17,1.84,4.46,4.21,10.9,7.42,18.42l.1.24-.25.07-19,5.67.19-.25v3.5c0,4.18,0,8.24,0,12.07l-.25-.25a222.33,222.33,0,0,0,27.59-1.9c3.42-.48,6.1-1.08,7.94-1.51.92-.22,1.61-.45,2.09-.57A3.78,3.78,0,0,1,415.83,233.21Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "396.53px 214.395px",
        }}
        id="elrnz0kqczmpq"
        className="animable"
      />
      <path
        d="M405.85,223.89a23.32,23.32,0,0,0-9.84-7.53,5.16,5.16,0,0,1,1.81.48,15.64,15.64,0,0,1,3.93,2.21,16,16,0,0,1,3.17,3.22A5.13,5.13,0,0,1,405.85,223.89Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "400.93px 220.125px",
        }}
        id="elcnrg2pplewk"
        className="animable"
      />
      <path
        d="M274.26,115.13c-16.77,5.29-20.54,22.67-21.38,34.28s-1.62,22.37-2.43,34a103.73,103.73,0,0,1-33.69,69.1c-3.18,2.87-6.58,5.58-9,9.12s-3.68,8.16-2.1,12.14c1.7,4.29,6.33,7,7.7,11.41,2.27,7.31-5.17,13.54-10.07,19.43a34.91,34.91,0,0,0-7.53,27.28c1,6.64,5.39,13.87,12.11,14.05,3.89.1,7.38-2.22,10.56-4.47q14.53-10.24,28.77-20.94c14.45-10.86,29.06-22.51,37.67-38.4,7.44-13.72,9.82-29.57,11.19-45.12,3.58-40.58.89-82.47-14.53-120.17"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "246.423px 230.537px",
        }}
        id="el7biix4iawl9"
        className="animable"
      />
      <path
        d="M212,261a1.16,1.16,0,0,1,.33.16,4.85,4.85,0,0,1,.82.62,7.29,7.29,0,0,1,2,3.23,8.93,8.93,0,0,1-.11,5.61,13.82,13.82,0,0,1-3.87,5.68l-.65.57-.28.24-.13-.34a26.92,26.92,0,0,1-1.83-6.32,10.73,10.73,0,0,1,.53-5.31,7.49,7.49,0,0,1,2-3,5.23,5.23,0,0,1,.78-.58,1.05,1.05,0,0,1,.31-.15s-.37.28-.95.87a8,8,0,0,0-1.79,3,10.85,10.85,0,0,0-.4,5.13,28.67,28.67,0,0,0,1.85,6.19l-.41-.11c.2-.17.43-.36.64-.56a13.72,13.72,0,0,0,3.77-5.45,8.77,8.77,0,0,0,.21-5.35,7.51,7.51,0,0,0-1.79-3.18C212.4,261.26,212,261,212,261Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "211.853px 269.055px",
        }}
        id="elqlxillk7gpp"
        className="animable"
      />
      <path
        d="M215.61,276a3,3,0,0,0-.94,1.57,1.85,1.85,0,0,0,.54,1.74,2,2,0,0,0,3.36-1.36,1.9,1.9,0,0,0-.83-1.63,3,3,0,0,0-1.77-.47s.16-.13.51-.18a2.34,2.34,0,0,1,2.57,2.29,2.55,2.55,0,0,1-1.51,2.29,2.51,2.51,0,0,1-2.67-.6,2.33,2.33,0,0,1,.25-3.42C215.4,276,215.6,276,215.61,276Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "216.644px 278.033px",
        }}
        id="elusz6354tyxj"
        className="animable"
      />
      <path
        d="M219,272.87a14.45,14.45,0,0,0,2.65-1.79,9.28,9.28,0,0,0,2-2.75,8.92,8.92,0,0,0,.63-1.91,3.46,3.46,0,0,0,0-2,.47.47,0,0,0-.63-.25,3.14,3.14,0,0,0-.81.58,10.07,10.07,0,0,0-1.4,1.46,11.21,11.21,0,0,0-1.69,3,22,22,0,0,0-.77,3.11,2.2,2.2,0,0,1,0-.87,9.12,9.12,0,0,1,.46-2.36,10.7,10.7,0,0,1,1.65-3.16,11,11,0,0,1,1.44-1.56,3.87,3.87,0,0,1,1-.68,1,1,0,0,1,1.27.5,2.39,2.39,0,0,1,.22,1.24,10.06,10.06,0,0,1-.16,1.12,8.82,8.82,0,0,1-2.9,4.84,7.67,7.67,0,0,1-2,1.26A2.44,2.44,0,0,1,219,272.87Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "221.983px 268.245px",
        }}
        id="elgb1mbfa3vel"
        className="animable"
      />
      <path
        d="M218.75,280.91s.1,0,.31-.07a4.55,4.55,0,0,1,.93,0,7.17,7.17,0,0,1,3.21,1.09,10.14,10.14,0,0,1,3.46,3.66,17.19,17.19,0,0,1,1.25,2.7c.18.48.35,1,.5,1.49.08.26.16.49.23.79a1.21,1.21,0,0,1-.14,1,.72.72,0,0,1-.55.27,1.64,1.64,0,0,1-.48-.09l-.76-.28c-.5-.19-1-.39-1.45-.61a14.36,14.36,0,0,1-2.56-1.54,8.47,8.47,0,0,1-3-4,6.23,6.23,0,0,1-.2-3.38,4.16,4.16,0,0,1,.3-.88c.1-.19.15-.28.17-.27s-.15.42-.27,1.19a6.36,6.36,0,0,0,.35,3.22,8.29,8.29,0,0,0,3,3.78,13.67,13.67,0,0,0,2.49,1.45c.45.22.93.41,1.42.6s1.11.47,1.19.26,0-.83-.17-1.31-.31-1-.49-1.46a17.28,17.28,0,0,0-1.19-2.64,10,10,0,0,0-3.23-3.59,7.62,7.62,0,0,0-3-1.2C219.19,280.92,218.75,281,218.75,280.91Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "223.72px 286.315px",
        }}
        id="elcq6nbwy14mv"
        className="animable"
      />
      <path
        d="M222.1,276.59a5.44,5.44,0,0,1,1.18-.61,13.23,13.23,0,0,1,3.5-.91,17.14,17.14,0,0,1,11.43,2.72l.14.09.53.33-.62.14a30.23,30.23,0,0,1-11.75.21,25.37,25.37,0,0,1-3.46-.86,5.13,5.13,0,0,1-1.21-.48c0-.09,1.78.53,4.73,1a32.08,32.08,0,0,0,11.58-.36l-.09.47-.14-.08a17.45,17.45,0,0,0-11.1-2.8A21.59,21.59,0,0,0,222.1,276.59Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "230.36px 276.995px",
        }}
        id="ell3xjyp48edi"
        className="animable"
      />
      <path
        d="M218.6,291.39a1.53,1.53,0,0,1,.8.17,3.35,3.35,0,0,1,1.62,1.52,3.57,3.57,0,0,1-.06,3.29,3.29,3.29,0,0,1-1.44,1.42,3.51,3.51,0,0,1-2.13.33,3.21,3.21,0,0,1-1.93-1,3.36,3.36,0,0,1-.85-1.83,3.06,3.06,0,0,1,1.26-3,3.2,3.2,0,0,1,2.15-.56c.53.07.78.23.77.26s-.29-.05-.78-.06a3.18,3.18,0,0,0-1.92.66,2.71,2.71,0,0,0-1,2.65,2.83,2.83,0,0,0,2.38,2.39,3,3,0,0,0,3.08-1.47,3.29,3.29,0,0,0,.15-2.9,3.4,3.4,0,0,0-1.38-1.5C218.88,291.5,218.59,291.44,218.6,291.39Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "217.981px 294.776px",
        }}
        id="eloh3x0ocpo9r"
        className="animable"
      />
      <path
        d="M214.12,300a1.26,1.26,0,0,1,.14.34,5.48,5.48,0,0,1,.23,1,8.42,8.42,0,0,1-.43,3.92,10.34,10.34,0,0,1-3.39,4.76,15.43,15.43,0,0,1-6.51,3l-1,.18-.3.06V313a12.64,12.64,0,0,1,1.66-6.6,12.23,12.23,0,0,1,3.73-4.08,11.84,11.84,0,0,1,3.34-1.61,5.18,5.18,0,0,1,1.32-.28,16.75,16.75,0,0,0-4.45,2.18,12.38,12.38,0,0,0-3.53,4A12.52,12.52,0,0,0,203.4,313l-.31-.25,1-.18a15.28,15.28,0,0,0,6.32-2.84,10.37,10.37,0,0,0,3.35-4.5,9.11,9.11,0,0,0,.57-3.78C214.22,300.51,214.07,300,214.12,300Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "208.707px 306.63px",
        }}
        id="elqjhcyj1qlmp"
        className="animable"
      />
      <path
        d="M200.3,318.91s.06-.22.37-.48a2.18,2.18,0,0,1,1.6-.42,2.13,2.13,0,0,1,1.11.44,2,2,0,0,1,.74,1.18,2.49,2.49,0,0,1-1.29,2.72,2.54,2.54,0,0,1-2.92-.71,2.32,2.32,0,0,1-.35-2.44,2.49,2.49,0,0,1,1.1-1.24c.35-.19.57-.19.58-.17s-.18.12-.47.34a2.43,2.43,0,0,0-.86,1.2,1.94,1.94,0,0,0,.36,2,2.11,2.11,0,0,0,2.34.56,2,2,0,0,0,1-2.15,1.68,1.68,0,0,0-1.42-1.36,2.14,2.14,0,0,0-1.44.23C200.47,318.78,200.34,318.94,200.3,318.91Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "201.767px 320.163px",
        }}
        id="elozp1frhxnhp"
        className="animable"
      />
      <path
        d="M205.84,319.7a13.44,13.44,0,0,0,4.39,1.39,10.25,10.25,0,0,0,9.55-4.36l.2-.29.16.4a18.35,18.35,0,0,0-10.69,1,30.44,30.44,0,0,0-4,2.16,4,4,0,0,1,.93-.8,15.23,15.23,0,0,1,2.9-1.69,17.93,17.93,0,0,1,10.94-1.22l.38.08-.21.31-.21.31a10.67,10.67,0,0,1-4.94,3.86,10.24,10.24,0,0,1-5.09.56,9.9,9.9,0,0,1-3.29-1.05A3.64,3.64,0,0,1,205.84,319.7Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "213.025px 318.722px",
        }}
        id="elf60ils3lsp9"
        className="animable"
      />
      <path
        d="M200.49,326.65s0-.2.32-.4a1.63,1.63,0,0,1,1.4-.17,1.76,1.76,0,0,1,1.19,1.71A2.14,2.14,0,0,1,203,329a2.31,2.31,0,0,1-1.11.83,2.45,2.45,0,0,1-2.52-.46,1.47,1.47,0,0,1-.45-1.11,1.89,1.89,0,0,1,.31-1,3,3,0,0,1,1-.94c.27-.16.43-.23.45-.2s-.1.15-.33.36a3.75,3.75,0,0,0-.82,1,1.25,1.25,0,0,0,.16,1.55,2,2,0,0,0,2,.31,1.69,1.69,0,0,0,1.18-1.58,1.39,1.39,0,0,0-.84-1.37,1.5,1.5,0,0,0-1.17,0C200.64,326.54,200.52,326.67,200.49,326.65Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "201.16px 327.995px",
        }}
        id="elbv2ts7y85wj"
        className="animable"
      />
      <path
        d="M222,304.61a6.75,6.75,0,0,1-1.22,1.85,22.74,22.74,0,0,1-8.47,6.44,7.18,7.18,0,0,1-2.11.68,47.24,47.24,0,0,0,6.41-3.81A49.21,49.21,0,0,0,222,304.61Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "216.1px 309.095px",
        }}
        id="elgi1xlqci2sk"
        className="animable"
      />
      <path
        d="M236.89,290.16c-.15,0-.77-1.8-2.18-3.7s-3-3.06-2.87-3.19a7.91,7.91,0,0,1,3.29,2.88A8,8,0,0,1,236.89,290.16Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "234.361px 286.715px",
        }}
        id="el4ja79yxxurc"
        className="animable"
      />
      <path
        d="M234.57,263.62a17.41,17.41,0,0,1-2.85,4.84,17.62,17.62,0,0,1-3.88,4.07c-.11-.11,1.61-1.92,3.46-4.38S234.44,263.55,234.57,263.62Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "231.202px 268.074px",
        }}
        id="ell8z5504oyes"
        className="animable"
      />
      <path
        d="M223.44,254.12a17.23,17.23,0,0,0-5.41,9.31,11.18,11.18,0,0,1,5.41-9.31Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "220.735px 258.775px",
        }}
        id="elyzyldsc2bb"
        className="animable"
      />
      <path
        d="M229.66,258a13.36,13.36,0,0,0,3-1.8,8.45,8.45,0,0,0,2.85-7.44h0l.33.22A8.94,8.94,0,0,0,232,251.3a9.54,9.54,0,0,0-2,3.12,13.3,13.3,0,0,0-.78,3.39,2.82,2.82,0,0,1-.07-1,8.07,8.07,0,0,1,.5-2.57,9.59,9.59,0,0,1,2-3.32,9.18,9.18,0,0,1,4.05-2.52l.3-.09,0,.3h0a8.73,8.73,0,0,1-.73,4.72,8.43,8.43,0,0,1-2.41,3.08,7.88,7.88,0,0,1-2.28,1.28A2.84,2.84,0,0,1,229.66,258Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "232.6px 253.155px",
        }}
        id="elsdkwsxgrs1"
        className="animable"
      />
      <path
        d="M241.32,258.52s.17-.07.47,0a2,2,0,0,1,1.08.69,2.28,2.28,0,0,1,.48,1.87,2.23,2.23,0,0,1-3.95.64,2.24,2.24,0,0,1-.14-1.92,2,2,0,0,1,.81-1c.27-.16.44-.16.45-.14a2.77,2.77,0,0,0-.91,1.25,2,2,0,0,0,.19,1.56,1.68,1.68,0,0,0,1.69.65,1.65,1.65,0,0,0,1.39-1.15,1.93,1.93,0,0,0-.31-1.53C242,258.62,241.29,258.61,241.32,258.52Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "241.248px 260.573px",
        }}
        id="elq83hbl2cdr"
        className="animable"
      />
      <path
        d="M238.25,270.73a3.24,3.24,0,0,1,1-.54,10,10,0,0,1,2.87-.79,11.84,11.84,0,0,1,4.43.26,11.13,11.13,0,0,1,2.46.95,10.23,10.23,0,0,1,1.21.73,2.55,2.55,0,0,1,.55.54,1.1,1.1,0,0,1,.21.88,1.07,1.07,0,0,1-.58.69,2.74,2.74,0,0,1-.74.23l-1.36.22a21.86,21.86,0,0,1-2.6.27,10.08,10.08,0,0,1-4.39-.67,6.41,6.41,0,0,1-2.45-1.71,2.55,2.55,0,0,1-.58-.93,7.32,7.32,0,0,0,3.17,2.3,10,10,0,0,0,4.23.53,21.59,21.59,0,0,0,2.54-.3l1.34-.22c.43-.07.86-.24.91-.53s-.23-.64-.56-.89-.75-.49-1.13-.69a11.53,11.53,0,0,0-2.35-.94,12.05,12.05,0,0,0-4.27-.36A17.14,17.14,0,0,0,238.25,270.73Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "244.625px 271.748px",
        }}
        id="elhb52gw9a436"
        className="animable"
      />
      <path
        d="M243.08,282.81s.15-.15.52-.23a2.58,2.58,0,0,1,1.54.2,2.29,2.29,0,0,1,1.37,1.89,2.47,2.47,0,0,1-1.41,2.47,2.33,2.33,0,0,1-2.71-.87,1.87,1.87,0,0,1-.32-1.28,2,2,0,0,1,.46-1,1.93,1.93,0,0,1,1.38-.73c.39,0,.57.1.56.12s-.2,0-.53.08a1.89,1.89,0,0,0-1.12.76,1.49,1.49,0,0,0,0,1.81,1.86,1.86,0,0,0,2.11.65A2,2,0,0,0,246,284.7a1.94,1.94,0,0,0-1.05-1.59A3.43,3.43,0,0,0,243.08,282.81Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "244.289px 284.909px",
        }}
        id="elq6n8zl55gxb"
        className="animable"
      />
      <path
        d="M224.87,308.82c0-.09,1.78-.53,4.56-1.53a18.14,18.14,0,0,0,4.55-2.4,10.15,10.15,0,0,0,3.65-4.93c.07-.2.11-.4.16-.58l.28.31a16.08,16.08,0,0,0-9.66,4.88,25.17,25.17,0,0,0-2.73,3.67,5.25,5.25,0,0,1,.5-1.14,14.09,14.09,0,0,1,2-2.77,15.94,15.94,0,0,1,9.87-5.16l.38,0-.09.36c-.06.19-.1.41-.17.62a10.38,10.38,0,0,1-3.87,5.16,17.62,17.62,0,0,1-4.71,2.37c-1.42.48-2.59.76-3.4.95A5.15,5.15,0,0,1,224.87,308.82Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "231.65px 303.995px",
        }}
        id="el24cj5t1pc04h"
        className="animable"
      />
      <path
        d="M244.48,294.36s.06-.17.34-.32a1.59,1.59,0,0,1,1.27,0,1.63,1.63,0,0,1,1,1.62,1.93,1.93,0,0,1-1.45,1.81,2.21,2.21,0,0,1-2.23-.64A1.81,1.81,0,0,1,243,295a1.55,1.55,0,0,1,.91-.89c.3-.1.47,0,.47,0s-.16.06-.39.2a1.39,1.39,0,0,0-.23,2.24,1.79,1.79,0,0,0,1.75.47,1.47,1.47,0,0,0,1.1-1.33,1.26,1.26,0,0,0-.67-1.26,1.52,1.52,0,0,0-1.05-.13C244.64,294.3,244.51,294.39,244.48,294.36Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "245px 295.73px",
        }}
        id="elfge59j2go6q"
        className="animable"
      />
      <path
        d="M253.69,258.88s.17-.12.53-.13a2.23,2.23,0,0,1,1.4.49,2.54,2.54,0,0,1,1,2,2.39,2.39,0,0,1-1.66,2.15,2.36,2.36,0,0,1-2.64-.6,2.54,2.54,0,0,1-.48-2.18,2.2,2.2,0,0,1,.77-1.27c.28-.22.48-.25.49-.23a2.79,2.79,0,0,0-.9,1.57,2.25,2.25,0,0,0,.48,1.8,2.08,2.08,0,0,0,3.46-1.25,2.26,2.26,0,0,0-.78-1.69A2.91,2.91,0,0,0,253.69,258.88Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "254.194px 261.157px",
        }}
        id="el45hwmgwx01o"
        className="animable"
      />
      <path
        d="M243.49,245.74a2.1,2.1,0,0,1,2,0,2.53,2.53,0,0,1,.63,4.26,2.38,2.38,0,0,1-2.72.06,1.84,1.84,0,0,1-.74-1,2.05,2.05,0,0,1,0-1.07,2,2,0,0,1,.88-1.21c.32-.17.52-.16.53-.13s-.17.1-.42.3a1.9,1.9,0,0,0-.63,1.12,1.53,1.53,0,0,0,.67,1.6,1.91,1.91,0,0,0,2.12-.07,2.11,2.11,0,0,0,.68-2.06,2.19,2.19,0,0,0-1.14-1.46A4.07,4.07,0,0,0,243.49,245.74Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "244.805px 247.972px",
        }}
        id="elh5lkrpytxz9"
        className="animable"
      />
      <path
        d="M226.83,245.35s.07-.18.34-.36a2.1,2.1,0,0,1,1.32-.3,2.35,2.35,0,0,1,1.77,1,2.21,2.21,0,0,1-.12,2.48,2.24,2.24,0,0,1-2.28,1,2.37,2.37,0,0,1-1.57-1.3,2.18,2.18,0,0,1-.19-1.35c.08-.32.2-.46.22-.44a2.93,2.93,0,0,0,.29,1.62,2.13,2.13,0,0,0,1.34,1,1.93,1.93,0,0,0,1.91-2.76,2.09,2.09,0,0,0-1.41-.9A2.87,2.87,0,0,0,226.83,245.35Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "228.325px 246.942px",
        }}
        id="elt3hzajnvsjf"
        className="animable"
      />
      <path
        d="M273,131.79c.26-2.63,1.18-5.17,1.23-7.81s-1.1-5.6-3.58-6.49a5.42,5.42,0,0,0-5.35,1.35,9.64,9.64,0,0,0-2.59,5.09c-.84,4.06.21,8.79,3.59,11.19,1.45,1,3.52,1.53,5,.51s1.68-2.68,1.93-4.27"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "268.333px 126.725px",
        }}
        id="elvumqbw98qbp"
        className="animable"
      />
      <path
        d="M313,128c8.66-19.07-12-28.64-23.21-25.47-10.57,3-15.08,8.25-16.82,15.32s-1.66,14.74,1.11,21.48c1.37,3.32,3.83,6.7,7.4,7.11"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "293.435px 124.186px",
        }}
        id="elhnw6yuk4hb"
        className="animable"
      />
      <path
        d="M283,113.14a3.6,3.6,0,0,0-3.22,3.65h0l2,48.53c.08,5.73,8.45,9,14.58,8.84h0c6.2-.13,6.39-3.17,6.5-8.62.15-7.66.46-12.08.15-12.48,0,0,7.83-1.3,9.45-11.51.81-5.08.55-13.41.12-20.22-.38-6.13-4.44-13.65-10.55-13Z"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "296.383px 141.228px",
        }}
        id="el4602ric3j9x"
        className="animable"
      />
      <path
        d="M306,127.28a1.25,1.25,0,0,1-1.3-1.09,1.81,1.81,0,0,1,.75-1.63,3.3,3.3,0,0,1,1.76-.58,5.67,5.67,0,0,1,2.51.4,2,2,0,0,1,.78.48,1,1,0,0,1,.29.84c-.11.57-.76.81-1.32,1"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "307.746px 125.624px",
        }}
        id="elhi6nkx7mllu"
        className="animable"
      />
      <path
        d="M310.86,127.68c-.17.18-1.16-.56-2.57-.56s-2.44.71-2.6.54.09-.38.55-.71a3.51,3.51,0,0,1,2.07-.64,3.46,3.46,0,0,1,2.05.66C310.79,127.3,310.94,127.61,310.86,127.68Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "308.261px 127.009px",
        }}
        id="elxu4sajq7b8"
        className="animable"
      />
      <path
        d="M293.06,128.13a3.44,3.44,0,0,1-2.24-.09c-.46-.18-.94-.57-.88-1.06s.44-.68.8-.87a9.38,9.38,0,0,1,4.48-1,2.86,2.86,0,0,1,1.16.19,1.23,1.23,0,0,1,.75.84.81.81,0,0,1-.52.94"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "293.542px 126.691px",
        }}
        id="elu3d99cn413s"
        className="animable"
      />
      <path
        d="M297.63,128.32c-.15.17-1.17-.53-2.58-.49s-2.42.77-2.58.6.08-.38.53-.72a3.57,3.57,0,0,1,2.06-.7,3.42,3.42,0,0,1,2.05.6C297.56,127.93,297.71,128.24,297.63,128.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "295.035px 127.732px",
        }}
        id="el0ov0kevdohvl"
        className="animable"
      />
      <path
        d="M302.11,136.38a9.45,9.45,0,0,1,2.29-.41c.36,0,.7-.11.77-.36a1.86,1.86,0,0,0-.25-1.07c-.33-.87-.69-1.78-1.06-2.74-1.48-3.9-2.55-7.11-2.39-7.17s1.48,3.06,3,7c.36,1,.7,1.88,1,2.76a2.1,2.1,0,0,1,.19,1.42.92.92,0,0,1-.59.52,2.5,2.5,0,0,1-.62.09A9.52,9.52,0,0,1,302.11,136.38Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "303.581px 130.551px",
        }}
        id="elzgw5b0m6wfi"
        className="animable"
      />
      <path
        d="M303.09,153.06a25.89,25.89,0,0,1-13.68-3.65s3.45,7.1,13.68,6.14Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "296.25px 152.525px",
        }}
        id="eldrosvrhoijg"
        className="animable"
      />
      <path
        d="M301.52,139.78a2.57,2.57,0,0,0-2.28-.95,2.33,2.33,0,0,0-1.6.86,1.47,1.47,0,0,0-.11,1.68,1.69,1.69,0,0,0,1.84.47,5.29,5.29,0,0,0,1.81-1.07,1.77,1.77,0,0,0,.4-.42.5.5,0,0,0,0-.53"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "299.487px 140.378px",
        }}
        id="elr88fwptpt7n"
        className="animable"
      />
      <path
        d="M298,137.36c.23,0,.24,1.51,1.55,2.6s2.94.92,2.95,1.13-.37.3-1,.32a3.86,3.86,0,0,1-2.47-.86,3.32,3.32,0,0,1-1.19-2.18C297.69,137.73,297.86,137.35,298,137.36Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "300.141px 139.385px",
        }}
        id="elwv674tvtdy"
        className="animable"
      />
      <path
        d="M297.63,123.46c-.14.38-1.55.2-3.2.4s-3,.65-3.21.3c-.1-.16.13-.52.67-.89a5.4,5.4,0,0,1,2.38-.84,5.28,5.28,0,0,1,2.51.3C297.39,123,297.69,123.27,297.63,123.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "294.417px 123.34px",
        }}
        id="elzcg9jl2527d"
        className="animable"
      />
      <path
        d="M310.34,121.58c-.25.32-1.22,0-2.39,0s-2.16.22-2.38-.12c-.1-.16.05-.48.48-.78a3.29,3.29,0,0,1,1.94-.53,3.33,3.33,0,0,1,1.91.65C310.31,121.09,310.45,121.42,310.34,121.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "307.958px 120.935px",
        }}
        id="elihttz2ovzqr"
        className="animable"
      />
      <path
        d="M309.13,108.63a9.85,9.85,0,0,1-3.66,9.66,19.51,19.51,0,0,1-5.69,2.57l-3.84,1.26a32.24,32.24,0,0,1-8.67,2c.31,3.32.81,5.54-.84,8.45-1.48,2.6-3.73,4.49-6.79,3.91a99.61,99.61,0,0,1-2.13-19.86,9.36,9.36,0,0,1,.76-5c1.42-2.46,4.63-3.08,7.44-3.44l11.86-1.53a24.36,24.36,0,0,1,5.84-.28,8,8,0,0,1,5.16,2.47"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "293.373px 121.446px",
        }}
        id="elrhyx0hgtb6"
        className="animable"
      />
      <path
        d="M271.47,124.92s0,0,.11,0h.34a3.41,3.41,0,0,0,1.25-.35,5.45,5.45,0,0,0,1.6-1.27,24.07,24.07,0,0,0,1.6-2.17,9.93,9.93,0,0,1,2.22-2.28,13,13,0,0,1,3.25-1.69,28.47,28.47,0,0,1,8.35-1.34,38.89,38.89,0,0,0,8.5-1,12.19,12.19,0,0,0,6-3.58,9.33,9.33,0,0,0,1.51-2.25,7.26,7.26,0,0,0,.59-2,5.13,5.13,0,0,0,0-1.73c-.06,0,0,.62-.16,1.7a7.46,7.46,0,0,1-.64,1.88,9.31,9.31,0,0,1-1.52,2.16,12.13,12.13,0,0,1-5.87,3.41,39.67,39.67,0,0,1-8.43,1,28.11,28.11,0,0,0-8.45,1.39,13.63,13.63,0,0,0-3.32,1.78,10.11,10.11,0,0,0-2.26,2.39c-.56.82-1,1.59-1.53,2.18a5.31,5.31,0,0,1-1.51,1.28A3.81,3.81,0,0,1,271.47,124.92Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "289.167px 115.09px",
        }}
        id="el7hf0pfh5mqf"
        className="animable"
      />
      <path
        d="M272.79,118.58a3,3,0,0,1,.13-1.45,5.89,5.89,0,0,1,2.92-2.67,20,20,0,0,1,5.74-1.85,50.11,50.11,0,0,1,7.43-.33,34.82,34.82,0,0,0,7.48-.64,15.06,15.06,0,0,0,5.59-2.5,9.61,9.61,0,0,0,2.76-3.08,5.71,5.71,0,0,0,.46-1,1.8,1.8,0,0,0,.12-.37c-.05,0-.22.5-.71,1.32a10.16,10.16,0,0,1-2.8,2.92,15.13,15.13,0,0,1-5.51,2.37,35.8,35.8,0,0,1-7.39.6,47.26,47.26,0,0,0-7.49.37,19.39,19.39,0,0,0-5.81,2,5.88,5.88,0,0,0-2.94,2.86,2.4,2.4,0,0,0-.1,1.14A1.16,1.16,0,0,0,272.79,118.58Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "289.031px 111.635px",
        }}
        id="el9vsvmh7kvvh"
        className="animable"
      />
      <path
        d="M274,138.72a2.22,2.22,0,0,0,0-.54c0-.36,0-.88,0-1.55a17.17,17.17,0,0,1,.76-5.57,11.18,11.18,0,0,1,1.82-3.4,9,9,0,0,1,3.51-2.62c2.9-1.26,6.46-1.26,10.11-1.59A31.28,31.28,0,0,0,300.23,121a17,17,0,0,0,6.64-5.21,12.82,12.82,0,0,0,2.4-5.16,8.7,8.7,0,0,0,.19-1.55,3.72,3.72,0,0,0,0-.54s0,.75-.35,2a13.21,13.21,0,0,1-2.47,5,16.94,16.94,0,0,1-6.56,5,31.65,31.65,0,0,1-9.95,2.39c-3.62.33-7.22.33-10.22,1.66a9.28,9.28,0,0,0-3.62,2.75,10.91,10.91,0,0,0-1.83,3.52,16.44,16.44,0,0,0-.65,5.67c0,.67.08,1.19.12,1.54A3.83,3.83,0,0,0,274,138.72Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "291.625px 123.63px",
        }}
        id="elz37zsnsiwoc"
        className="animable"
      />
      <path
        d="M281.58,130.18c-.15-.08-5.47-2.43-5.53,3.69s6.09,4.91,6.1,4.74S281.58,130.18,281.58,130.18Z"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "279.1px 134.245px",
        }}
        id="elchouazmxtbn"
        className="animable"
      />
      <path
        d="M280.3,136.27s-.1.08-.28.16a1.08,1.08,0,0,1-.8,0,2.66,2.66,0,0,1-1.2-2.38,3.5,3.5,0,0,1,.32-1.52,1.2,1.2,0,0,1,.81-.81.53.53,0,0,1,.62.29c.08.18,0,.3.08.31s.13-.1.08-.36a.63.63,0,0,0-.24-.38.76.76,0,0,0-.58-.16,1.5,1.5,0,0,0-1.13.93,3.76,3.76,0,0,0-.38,1.7,2.75,2.75,0,0,0,1.52,2.66,1.15,1.15,0,0,0,1-.15C280.29,136.42,280.33,136.28,280.3,136.27Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "278.951px 134.088px",
        }}
        id="elroofjwh5pfn"
        className="animable"
      />
      <path
        d="M265.49,111.68a6.53,6.53,0,0,1,1.95,1.29,15.87,15.87,0,0,1,5.38,9.74,6.8,6.8,0,0,1,.06,2.34,21.93,21.93,0,0,1-.42-2.28,18.16,18.16,0,0,0-5.26-9.53C266.17,112.26,265.44,111.75,265.49,111.68Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "269.221px 118.365px",
        }}
        id="el18vuiwzlocc"
        className="animable"
      />
      <path
        d="M268,110.82a1.47,1.47,0,0,0-1.5-1.06,1.24,1.24,0,0,0-1.4,1.36,1.55,1.55,0,0,0,1.63,1.46A1.51,1.51,0,0,0,268,110.82Z"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "266.558px 111.165px",
        }}
        id="els1982fa9gr"
        className="animable"
      />
      <path
        d="M267.6,113.88a1.48,1.48,0,0,0-1.49-1.07,1.25,1.25,0,0,0-1.41,1.37,1.56,1.56,0,0,0,1.63,1.46A1.5,1.5,0,0,0,267.6,113.88Z"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "266.159px 114.22px",
        }}
        id="ele6p2u0fxf5c"
        className="animable"
      />
      <path
        d="M269.94,112.5a.94.94,0,0,0-1-.68.79.79,0,0,0-.9.87,1,1,0,0,0,1.05.94A1,1,0,0,0,269.94,112.5Z"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "268.992px 112.721px",
        }}
        id="elzmfw96z8h1"
        className="animable"
      />
      <path
        d="M271.8,119.32a10.2,10.2,0,0,0-6.37.09c-.2.07-.43.21-.4.41a.44.44,0,0,0,.25.27,4.25,4.25,0,0,0,3.37,0,18.71,18.71,0,0,1,3.15-.73"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "268.414px 119.646px",
        }}
        id="ele218hafdurr"
        className="animable"
      />
      <path
        d="M279.91,138a1.18,1.18,0,0,0-.56,1.38,1.16,1.16,0,0,0,1.18,1,1,1,0,0,0,.72-.47,1.43,1.43,0,0,0,.22-.85,1.34,1.34,0,0,0-.47-1,.89.89,0,0,0-1.09,0"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "280.385px 139.127px",
        }}
        id="elzzh0ke6vhp"
        className="animable"
      />
      <path
        d="M342.29,220.36l16.83-4.52,9,7c-.17.44-.79,4-.79,4l-2.37-1-1.38-3.34-3.58-.8s-4.2,2.31-4.4,2.48,9.9,1.41,11.73,4.15a2,2,0,0,1-1.71,1.88c-1.69.24-5.59-1.82-7.78-1.39s-5.86,1.7-7.66,1.48a11.69,11.69,0,0,1-3.17-.85l-7.94,2Z"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "353.595px 223.645px",
        }}
        id="elydwbkb6yvk"
        className="animable"
      />
      <path
        d="M317,201.59c.83,1.65,7.49,20.42,7.49,20.42l21.9-2.17.41,9.58-32.57,8.19Z"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "330.515px 219.6px",
        }}
        id="elmayx8oszu2h"
        className="animable"
      />
      <path
        d="M264.84,174.17s-2.29-7.69,15.74-11.77c4.17-.94,22.44.87,22.44.87s4.13,3.91,9.37,9.53c5.47,5.87,14.31,15.79,14,23.15s-3.09,32-4.15,37.28,4,29.11,5.2,44.29l-60.74,7.06s-4.81-10.79,4.65-27.26l11.74-28.95-7-18.87C277.48,197,289.38,176.77,264.84,174.17Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "296.093px 223.355px",
        }}
        id="eld84hlsykp4b"
        className="animable"
      />
      <path
        d="M315.06,243.33s11.42,22.09,16.9,41.94c5.27,19.07,58.24,168,48.69,174.22l-1.52-.7s9,2.25-6.73,10.11-68.51,14.6-115.12,12.35S187.08,495.85,182,488s0-9,0-9-53.35,7.3-63.46,2.8-3.37-9-3.37-9-105,.56-105.57-7.86,9-10.67,24.71-12.92S265,289.72,266.73,283.76"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "195.687px 366.715px",
        }}
        id="el23hfp5s35md"
        className="animable"
      />
      <path
        d="M280.38,299.58s-.06.24-.2.7-.35,1.16-.63,2.05a67,67,0,0,1-3.08,7.62,84.2,84.2,0,0,1-6.61,11.22A131.52,131.52,0,0,1,259,334.58c-4.29,4.74-9.24,9.69-14.58,15s-11.07,10.9-17.14,16.76c-12.15,11.73-25.67,24.46-40.11,37.54-7.23,6.54-14.34,12.86-21.29,18.88s-13.83,11.63-20.65,16.62A167.52,167.52,0,0,1,125,452.19a117.66,117.66,0,0,1-19.22,8.2A97.61,97.61,0,0,1,89,464.23,84.1,84.1,0,0,1,76,465a74.56,74.56,0,0,1-8.2-.7l-2.11-.34-.72-.13s.25,0,.73.08l2.11.29c1.87.24,4.63.5,8.19.6a87.51,87.51,0,0,0,13-.82,99.45,99.45,0,0,0,16.74-3.9,118,118,0,0,0,19.12-8.23A168.27,168.27,0,0,0,145,439c13.61-10,27.36-22.49,41.87-35.5s28-25.78,40.12-37.49c6.08-5.86,11.83-11.46,17.17-16.73s10.32-10.19,14.62-14.9A133.26,133.26,0,0,0,269.62,321a86.16,86.16,0,0,0,6.67-11.13,72.18,72.18,0,0,0,3.16-7.58c.3-.88.52-1.55.68-2S280.38,299.58,280.38,299.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "172.675px 382.297px",
        }}
        id="elg3izc6p8bnf"
        className="animable"
      />
      <path
        d="M275.9,294.57a7.91,7.91,0,0,1-2-1.14,25,25,0,0,1-4.16-3.54,14.41,14.41,0,0,1-3-4.6,5.45,5.45,0,0,1-.49-2.22c.09,0,.26.83.83,2.07a16.61,16.61,0,0,0,3,4.4,37.21,37.21,0,0,0,4,3.6A12.51,12.51,0,0,1,275.9,294.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "271.075px 288.82px",
        }}
        id="el2i1tpqrxrer"
        className="animable"
      />
      <path
        d="M146.91,417.41a3.59,3.59,0,0,1,.36-.25l1.07-.68,4.15-2.59,3-1.86,3.51-2.31c2.51-1.68,5.42-3.51,8.5-5.73l4.87-3.42c1.69-1.19,3.4-2.52,5.19-3.84,3.61-2.62,7.32-5.63,11.25-8.74,7.76-6.36,16.07-13.63,24.37-21.7s15.73-16.26,22.26-23.87c3.21-3.86,6.29-7.49,9-11,1.36-1.77,2.73-3.44,4-5.11s2.41-3.26,3.53-4.79c2.29-3,4.19-5.89,5.92-8.36l2.39-3.46,1.93-3,2.68-4.08.71-1.06a2.14,2.14,0,0,1,.26-.35,3.15,3.15,0,0,1-.21.38c-.17.26-.39.62-.67,1.08l-2.6,4.14c-.57.9-1.2,1.9-1.9,3s-1.5,2.23-2.35,3.48c-1.71,2.49-3.59,5.37-5.86,8.42l-3.51,4.82c-1.23,1.67-2.58,3.35-3.94,5.12-2.69,3.57-5.77,7.22-9,11.09-6.53,7.64-14,15.8-22.27,23.93S196.9,382,189.11,388.36c-3.94,3.11-7.66,6.11-11.29,8.72-1.8,1.31-3.51,2.63-5.21,3.82l-4.9,3.4c-3.1,2.2-6,4-8.55,5.66-1.27.82-2.44,1.59-3.54,2.28l-3,1.82-4.2,2.51-1.09.64A2.06,2.06,0,0,1,146.91,417.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "206.385px 359.31px",
        }}
        id="el7gke8lvlhek"
        className="animable"
      />
      <path
        d="M287.08,319.23s0,.17-.11.48-.22.78-.39,1.37l-1.51,5.28-1.1,3.81c-.43,1.38-1,2.87-1.5,4.47-1.1,3.2-2.24,6.89-3.85,10.84l-2.42,6.24c-.85,2.17-1.87,4.36-2.85,6.67-1.92,4.63-4.33,9.42-6.8,14.49A311.53,311.53,0,0,1,248,404.48a312.47,312.47,0,0,1-22.48,29c-3.8,4.17-7.35,8.18-11,11.68-1.78,1.77-3.44,3.53-5.13,5.12l-4.91,4.55c-3.07,3-6.08,5.38-8.64,7.59-1.29,1.1-2.48,2.14-3.6,3.05l-3.13,2.44-4.34,3.35-1.14.87-.4.28s.12-.12.37-.33l1.1-.9,4.28-3.43,3.1-2.47c1.12-.93,2.29-2,3.57-3.08,2.54-2.23,5.53-4.67,8.58-7.64,1.56-1.45,3.18-3,4.88-4.57s3.34-3.36,5.1-5.14c3.58-3.5,7.12-7.52,10.9-11.68a318,318,0,0,0,22.41-28.95,319.75,319.75,0,0,0,18.59-31.52c2.46-5.05,4.89-9.83,6.82-14.44,1-2.3,2-4.49,2.88-6.65l2.45-6.22c1.62-3.94,2.78-7.61,3.92-10.8.54-1.6,1.09-3.08,1.53-4.46s.8-2.65,1.15-3.79c.69-2.26,1.23-4,1.6-5.25.19-.58.33-1,.43-1.36S287.08,319.23,287.08,319.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "235.155px 395.82px",
        }}
        id="elz545febpe1"
        className="animable"
      />
      <path
        d="M300.88,320.37s0,.15,0,.43v1.26c0,1.13,0,2.76-.06,4.83,0,1.06,0,2.22-.05,3.5s-.17,2.66-.26,4.14c-.23,3-.35,6.38-.87,10.1-.23,1.86-.46,3.82-.7,5.85s-.68,4.13-1,6.31c-.65,4.37-1.74,9-2.81,13.81a234.07,234.07,0,0,1-9.88,30.73,234.54,234.54,0,0,1-14.39,28.91c-2.63,4.22-5,8.27-7.64,11.85-1.27,1.81-2.43,3.6-3.66,5.23L256,452c-2.22,3-4.51,5.55-6.42,7.84-1,1.13-1.86,2.2-2.71,3.15s-1.68,1.77-2.4,2.54l-3.34,3.5-.87.9a2.66,2.66,0,0,1-.31.29,1.63,1.63,0,0,1,.27-.33L241,469l3.26-3.56,2.36-2.57c.84-.95,1.71-2,2.67-3.17,1.89-2.3,4.16-4.84,6.36-7.87l3.55-4.69c1.23-1.64,2.38-3.43,3.64-5.24,2.57-3.59,5-7.64,7.57-11.85a237.32,237.32,0,0,0,14.33-28.86,238.34,238.34,0,0,0,9.89-30.65c1.08-4.84,2.19-9.42,2.85-13.78.36-2.17.79-4.26,1.06-6.29s.5-4,.73-5.83c.55-3.72.69-7.11,1-10.07.1-1.49.24-2.87.3-4.14s.07-2.44.1-3.49c.07-2.08.12-3.7.16-4.83,0-.53,0-.95,0-1.26A2,2,0,0,1,300.88,320.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "270.415px 395.295px",
        }}
        id="eldfxxphjed8"
        className="animable"
      />
      <path
        d="M316.48,397.32a.6.6,0,0,1,0-.23c0-.19,0-.42,0-.7,0-.65,0-1.54.07-2.66.09-2.31.17-5.66.22-9.79.11-8.27-.05-19.69-.93-32.28s-2.35-23.92-3.63-32.09c-.63-4.08-1.18-7.38-1.59-9.66l-.45-2.62-.1-.69a.8.8,0,0,1,0-.23s0,.07.07.22l.15.68c.14.64.32,1.51.55,2.61.47,2.26,1.08,5.55,1.76,9.64,1.36,8.16,2.88,19.5,3.78,32.11s1,24,.78,32.32c-.1,4.13-.24,7.48-.39,9.79-.07,1.12-.12,2-.17,2.66,0,.28,0,.5-.05.69A.89.89,0,0,1,316.48,397.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "313.66px 351.845px",
        }}
        id="elkqml0a3owod"
        className="animable"
      />
      <path
        d="M380.65,459.49l.18.18a2.49,2.49,0,0,1,.46.61,2.14,2.14,0,0,1,.29,1.22,3.42,3.42,0,0,1-.71,1.6,13.53,13.53,0,0,1-3.92,3,50.45,50.45,0,0,1-6.17,2.87,162.27,162.27,0,0,1-18,5.74c-7.16,2.11-15.68,3.24-25.19,4.21s-20.06,1.73-31.54,2.33-23.9,1.06-37.16,1c-1.66,0-3.33-.05-5-.09l-2.53-.07-2.55-.15c-.86-.06-1.71-.09-2.57-.16l-2.59-.29L241,481.2a20.67,20.67,0,0,0-2.61-.17c-7-.12-14.15,1.3-21.34,3s-14.49,3.88-22.12,5.45c-.95.21-1.91.35-2.88.51a28.73,28.73,0,0,1-2.94.33l-.74.06-.75,0-1.5,0a10.76,10.76,0,0,1-2.93-.73,5.34,5.34,0,0,1-2.43-1.88,5.17,5.17,0,0,1-.82-3,12.46,12.46,0,0,1,1.87-5.82l.23.36c-11.74,1.72-24,3.23-36.75,4.13a129.67,129.67,0,0,1-19.43.19c-.82-.1-1.64-.11-2.46-.29l-2.45-.49c-.79-.26-1.59-.5-2.37-.78l-1.16-.49-.58-.24-.55-.31a9.5,9.5,0,0,1-2.09-1.47,4.78,4.78,0,0,1-.81-1c-.1-.19-.22-.38-.31-.59l-.17-.65a4,4,0,0,1,.47-2.57,7,7,0,0,1,1.65-2l.15.45c-16.26-.22-33.12-.51-50.41-.95l-13.05-.39c-4.37-.14-8.77-.3-13.2-.6s-8.85-.82-13.26-1.55a77.84,77.84,0,0,1-13.09-3.27,27.1,27.1,0,0,1-2.68-1.12l-.11-.06,0-.12a6.64,6.64,0,0,1,.44-4,8.56,8.56,0,0,1,2.55-3.1,22.89,22.89,0,0,1,7-3.47,65.24,65.24,0,0,1,14.92-2.63l-.07,0a76.34,76.34,0,0,0,8.51-4.2c1.37-.79,2.75-1.55,4.1-2.37l4-2.45q8-5,15.69-10.2c10.28-6.91,20.24-13.91,30-20.85,19.46-13.89,38-27.53,55.5-40.55l49.58-37c15.48-11.57,29.83-22.37,43.1-32,3.33-2.37,6.58-4.71,9.89-6.76s6.48-4.21,8.54-7.24a11.86,11.86,0,0,0,1.92-5,42.09,42.09,0,0,0,.31-5.24,42.66,42.66,0,0,1,1.56-9.94,106.25,106.25,0,0,1,6.78-16.71,126.08,126.08,0,0,0,6-13.87c3-8.58,3.22-15.85,2.25-20.49a14.19,14.19,0,0,0-.37-1.64c-.15-.5-.25-1-.4-1.41-.32-.84-.54-1.57-.8-2.12-.52-1.1-.78-1.67-.78-1.67s.29.55.82,1.65c.27.55.5,1.28.83,2.12.16.43.26.91.41,1.41a13.63,13.63,0,0,1,.39,1.64c1,4.66.81,12-2.17,20.57a124.29,124.29,0,0,1-6,13.91,106.64,106.64,0,0,0-6.72,16.69,42.06,42.06,0,0,0-1.53,9.87,43.07,43.07,0,0,1-.31,5.28,12,12,0,0,1-2,5.09c-2.1,3.12-5.35,5.3-8.63,7.35s-6.53,4.39-9.85,6.77c-13.26,9.6-27.59,20.42-43.06,32l-49.55,37.07c-17.53,13-36,26.67-55.49,40.58-9.73,6.94-19.69,14-30,20.87q-7.71,5.19-15.71,10.21l-4,2.46c-1.35.82-2.74,1.58-4.11,2.37a76.75,76.75,0,0,1-8.58,4.23l0,0h0a64.46,64.46,0,0,0-14.79,2.61,22.26,22.26,0,0,0-6.88,3.37,8.25,8.25,0,0,0-2.4,2.92,6.12,6.12,0,0,0-.4,3.71l-.13-.18a25.31,25.31,0,0,0,2.62,1.09,77.12,77.12,0,0,0,13,3.24q6.6,1.11,13.22,1.55c4.41.3,8.8.46,13.18.6l13,.39c17.29.45,34.15.74,50.4,1h.67l-.51.44c-1.19,1-2.21,2.56-1.94,4.11s1.71,2.64,3.13,3.38l.53.3.56.24,1.13.48c.78.27,1.56.51,2.34.76l2.39.48c.8.18,1.62.19,2.43.29a130,130,0,0,0,19.35-.18c12.71-.9,25-2.4,36.71-4.11l.48-.07-.25.42a12.09,12.09,0,0,0-1.8,5.57,4.67,4.67,0,0,0,.74,2.72,4.85,4.85,0,0,0,2.22,1.72,10.82,10.82,0,0,0,2.81.7l1.46.05.72,0,.73-.06a28.28,28.28,0,0,0,2.9-.33c1-.15,1.92-.29,2.87-.5,7.59-1.56,14.87-3.77,22.1-5.43s14.37-3.1,21.45-3a23.25,23.25,0,0,1,2.64.18l2.6.27,2.56.29c.86.07,1.71.11,2.56.16l2.54.15,2.53.08c1.68,0,3.35.1,5,.1,13.24.11,25.65-.34,37.13-.92s22-1.34,31.54-2.28,18-2,25.16-4.14a163.68,163.68,0,0,0,18-5.66A50.86,50.86,0,0,0,376.9,466a13.42,13.42,0,0,0,3.91-3,3.43,3.43,0,0,0,.72-1.55,2.18,2.18,0,0,0-.27-1.2,2.36,2.36,0,0,0-.45-.62A2.28,2.28,0,0,1,380.65,459.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "195.417px 350.305px",
        }}
        id="eld7uoa2n3b98"
        className="animable"
      />
      <path
        d="M329.72,279.65a5.9,5.9,0,0,1-.55-1.09l-1.34-3c-1.13-2.55-2.7-6.07-4.5-9.92s-3.51-7.32-4.75-9.82c-.58-1.17-1.06-2.16-1.46-3a5.33,5.33,0,0,1-.48-1.12,5.25,5.25,0,0,1,.66,1c.4.68.95,1.66,1.61,2.89,1.33,2.46,3.08,5.9,4.89,9.76s3.33,7.42,4.37,10c.52,1.3.92,2.35,1.19,3.09A5.77,5.77,0,0,1,329.72,279.65Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "323.18px 265.675px",
        }}
        id="elyckkz7f56m"
        className="animable"
      />
      <path
        d="M281.84,162.13c.05.18-4.11,1.15-8.77,3.47a36.08,36.08,0,0,0-5.63,3.52,27,27,0,0,1-2.19,1.69,9.93,9.93,0,0,1,2-2,29,29,0,0,1,5.63-3.7,36.71,36.71,0,0,1,6.27-2.42A12.24,12.24,0,0,1,281.84,162.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "273.545px 166.47px",
        }}
        id="elo9ihudrjxz"
        className="animable"
      />
      <path
        d="M338.42,415.55s.1.07.27.24a4.82,4.82,0,0,1,.63.82,7.29,7.29,0,0,1,1.05,3.64,9,9,0,0,1-1.61,5.38,13.9,13.9,0,0,1-5.26,4.43l-.78.38-.33.15,0-.37a26.85,26.85,0,0,1-.06-6.57,10.83,10.83,0,0,1,1.94-5,7.58,7.58,0,0,1,2.71-2.34,4.45,4.45,0,0,1,.91-.35c.22-.06.33-.08.34-.06s-.44.17-1.16.59a7.89,7.89,0,0,0-2.51,2.37,10.76,10.76,0,0,0-1.77,4.84,28.16,28.16,0,0,0,.12,6.45l-.37-.21c.24-.11.51-.23.76-.37a13.53,13.53,0,0,0,5.1-4.23,8.7,8.7,0,0,0,1.64-5.1,7.5,7.5,0,0,0-.86-3.54C338.72,416,338.38,415.59,338.42,415.55Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "336.265px 423.07px",
        }}
        id="eli4649idk94"
        className="animable"
      />
      <path
        d="M337.84,431a3,3,0,0,0-1.33,1.25,1.88,1.88,0,0,0,.05,1.82,2.12,2.12,0,0,0,1.94,1,2.08,2.08,0,0,0,1.66-1.43,1.88,1.88,0,0,0-.35-1.79,3.08,3.08,0,0,0-1.58-.92s.19-.09.54,0a2.34,2.34,0,0,1,1.31.72,2.23,2.23,0,0,1,.54,2.17,2.4,2.4,0,0,1-4.47.51,2.2,2.2,0,0,1,0-2.23,2.29,2.29,0,0,1,1.11-1C337.64,431,337.84,431,337.84,431Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "338.277px 433.267px",
        }}
        id="elxj6h4ckbd0k"
        className="animable"
      />
      <path
        d="M342,428.91a13.79,13.79,0,0,0,3-1,9,9,0,0,0,2.68-2.11,8.7,8.7,0,0,0,1.12-1.67,3.4,3.4,0,0,0,.53-1.94.48.48,0,0,0-.54-.42,3.26,3.26,0,0,0-.94.34,9.89,9.89,0,0,0-1.74,1,11.12,11.12,0,0,0-2.43,2.42,22.09,22.09,0,0,0-1.58,2.79,2.33,2.33,0,0,1,.2-.85,9.08,9.08,0,0,1,1.08-2.15,10.81,10.81,0,0,1,2.44-2.6,10.41,10.41,0,0,1,1.81-1.11,3.68,3.68,0,0,1,1.12-.39,1,1,0,0,1,.7.19,1,1,0,0,1,.39.63,2.47,2.47,0,0,1-.13,1.25,7.46,7.46,0,0,1-.46,1,8.9,8.9,0,0,1-1.21,1.75,8.8,8.8,0,0,1-2.88,2.12,7.12,7.12,0,0,1-2.31.67A2.17,2.17,0,0,1,342,428.91Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "345.935px 425.068px",
        }}
        id="elcluynvfalct"
        className="animable"
      />
      <path
        d="M339.55,436.58s.11,0,.32,0a4.37,4.37,0,0,1,.9.23,7.28,7.28,0,0,1,2.8,1.92,10.23,10.23,0,0,1,2.34,4.45,17.18,17.18,0,0,1,.48,2.94c0,.52.07,1,.08,1.57,0,.28,0,.52,0,.82a1.25,1.25,0,0,1-.4.92.73.73,0,0,1-.6.11,1.39,1.39,0,0,1-.44-.21l-.66-.48c-.43-.31-.84-.64-1.23-1a14.45,14.45,0,0,1-2.06-2.17,8.4,8.4,0,0,1-1.8-4.69,6.21,6.21,0,0,1,.71-3.32,3.54,3.54,0,0,1,.53-.76c.14-.16.22-.23.24-.22s-.26.36-.59,1.07a6.32,6.32,0,0,0-.52,3.2,8.17,8.17,0,0,0,1.82,4.43,14.43,14.43,0,0,0,2,2.08c.39.32.79.64,1.21.95s.94.75,1.08.57.19-.8.18-1.31,0-1-.07-1.54a17.1,17.1,0,0,0-.44-2.86,10.07,10.07,0,0,0-2.15-4.33,7.64,7.64,0,0,0-2.6-2C340,436.7,339.54,436.62,339.55,436.58Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "342.868px 443.071px",
        }}
        id="elm0h00gwar6"
        className="animable"
      />
      <path
        d="M343.94,433.32a5.36,5.36,0,0,1,1.3-.27,13.85,13.85,0,0,1,3.61.06,17.17,17.17,0,0,1,10.28,5.7l.11.12.42.47-.63,0a30.12,30.12,0,0,1-11.37-2.95,25.1,25.1,0,0,1-3.1-1.76,5.94,5.94,0,0,1-1.05-.79c.06-.08,1.58,1,4.3,2.22a32.28,32.28,0,0,0,11.25,2.76l-.22.43-.1-.11a17.37,17.37,0,0,0-9.95-5.68A21.28,21.28,0,0,0,343.94,433.32Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "351.585px 436.18px",
        }}
        id="elqtulwo4xeu"
        className="animable"
      />
      <path
        d="M336.59,446.64s.3,0,.72.37a3.33,3.33,0,0,1,1.15,1.9,3.59,3.59,0,0,1-.94,3.16,3.37,3.37,0,0,1-1.77,1,3.61,3.61,0,0,1-2.14-.26,3.23,3.23,0,0,1-1.59-1.48,3.43,3.43,0,0,1-.33-2,3.06,3.06,0,0,1,2-2.57,3.22,3.22,0,0,1,2.22,0c.49.21.69.44.67.46s-.26-.13-.74-.27a3.28,3.28,0,0,0-2,.12,2.69,2.69,0,0,0-1.68,2.29,2.82,2.82,0,0,0,1.65,2.94,3,3,0,0,0,3.35-.59,3.25,3.25,0,0,0,.93-2.75,3.35,3.35,0,0,0-.93-1.82C336.82,446.81,336.57,446.67,336.59,446.64Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "335.091px 449.846px",
        }}
        id="elgojfaiii04u"
        className="animable"
      />
      <path
        d="M330,453.72s0,.13,0,.38a5.37,5.37,0,0,1-.05,1.07,8.66,8.66,0,0,1-1.47,3.66,10.57,10.57,0,0,1-4.55,3.67,15.48,15.48,0,0,1-7.07,1.11c-.34,0-.68-.06-1-.09l-.29,0,.07-.29a12.78,12.78,0,0,1,3.38-5.92,12.3,12.3,0,0,1,8.34-3.58,4.55,4.55,0,0,1,1.35.1,16.43,16.43,0,0,0-4.87.9,12.28,12.28,0,0,0-4.49,2.91,12.58,12.58,0,0,0-3.2,5.72l-.23-.33c.31,0,.64.07,1,.09a15.52,15.52,0,0,0,6.86-1,10.38,10.38,0,0,0,4.43-3.44,9.21,9.21,0,0,0,1.57-3.49C329.91,454.24,329.9,453.72,330,453.72Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "322.789px 458.687px",
        }}
        id="els47psluoxq"
        className="animable"
      />
      <path
        d="M311.56,468.22s.11-.21.48-.37a2.3,2.3,0,0,1,2.61.75,2,2,0,0,1,.39,1.34,2.49,2.49,0,0,1-2,2.27,2.55,2.55,0,0,1-2.62-1.47,2.33,2.33,0,0,1,.32-2.45,2.52,2.52,0,0,1,1.39-.9c.39-.08.6,0,.6,0s-.21.07-.54.2a2.56,2.56,0,0,0-1.16.92,2,2,0,0,0-.18,2A2.12,2.12,0,0,0,313,471.7a2,2,0,0,0,1.57-1.8,1.7,1.7,0,0,0-1-1.69,2.17,2.17,0,0,0-1.45-.17C311.76,468.13,311.58,468.26,311.56,468.22Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "312.627px 469.791px",
        }}
        id="el1r0huuelax8"
        className="animable"
      />
      <path
        d="M316.68,470.47a13.61,13.61,0,0,0,3.85,2.51,10.19,10.19,0,0,0,4.87.69,10.45,10.45,0,0,0,5.51-2.31l.26-.23.06.43a18.38,18.38,0,0,0-10.58-1.87,31.74,31.74,0,0,0-4.41,1,5.22,5.22,0,0,1,1.11-.52,15.68,15.68,0,0,1,3.25-.84,17.89,17.89,0,0,1,10.87,1.77l.34.17-.29.25-.28.24a10.61,10.61,0,0,1-5.79,2.39,10.3,10.3,0,0,1-5.06-.83,10,10,0,0,1-2.89-1.89A3.85,3.85,0,0,1,316.68,470.47Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "324.025px 471.658px",
        }}
        id="ele95yn8enbn8"
        className="animable"
      />
      <path
        d="M309.65,475.71s.1-.18.42-.29a1.64,1.64,0,0,1,1.39.21,1.74,1.74,0,0,1,.69,2,2,2,0,0,1-.69,1.09,2.27,2.27,0,0,1-1.29.51,2.45,2.45,0,0,1-2.3-1.12,1.49,1.49,0,0,1-.14-1.19,2,2,0,0,1,.56-.85,3.17,3.17,0,0,1,1.23-.63c.31-.08.48-.1.49-.07s-.14.12-.42.26a3.43,3.43,0,0,0-1,.71,1.24,1.24,0,0,0-.27,1.53,2,2,0,0,0,1.85.84,1.7,1.7,0,0,0,1.56-1.21,1.38,1.38,0,0,0-.44-1.54,1.53,1.53,0,0,0-1.13-.31C309.83,475.66,309.68,475.75,309.65,475.71Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "309.952px 477.296px",
        }}
        id="el30zaspdnjkf"
        className="animable"
      />
      <path
        d="M336.33,460.29a7.38,7.38,0,0,1-1.68,1.45,22.59,22.59,0,0,1-9.89,3.92,6.64,6.64,0,0,1-2.21.09,46.75,46.75,0,0,0,7.2-1.95A49.34,49.34,0,0,0,336.33,460.29Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "329.44px 463.047px",
        }}
        id="elf5yovdntvln"
        className="animable"
      />
      <path
        d="M354.53,450.37c-.15,0-.25-1.94-1.1-4.15s-2-3.75-1.91-3.85a10.05,10.05,0,0,1,3,8Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "353.034px 446.37px",
        }}
        id="elt6l1eosyacc"
        className="animable"
      />
      <path
        d="M359.44,424.19a24.57,24.57,0,0,1-8.88,6.76c-.08-.13,2.07-1.41,4.51-3.28S359.33,424.08,359.44,424.19Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "354.999px 427.568px",
        }}
        id="el7pgavi9dojl"
        className="animable"
      />
      <path
        d="M351.27,412a24.76,24.76,0,0,0-4.46,3.14,25.22,25.22,0,0,0-3.25,4.37,11.14,11.14,0,0,1,7.71-7.51Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "347.415px 415.755px",
        }}
        id="elhcgqas3fycu"
        className="animable"
      />
      <path
        d="M356.23,417.42a13.47,13.47,0,0,0,3.36-.92,8.45,8.45,0,0,0,4.75-6.41h0l.26.3a9,9,0,0,0-4.35,1.24,9.7,9.7,0,0,0-2.81,2.45,14,14,0,0,0-1.66,3.06,2.63,2.63,0,0,1,.19-.94,7.94,7.94,0,0,1,1.18-2.34A9.48,9.48,0,0,1,360,411.2a9.2,9.2,0,0,1,4.59-1.34h.31l-.05.31h0a8.77,8.77,0,0,1-2,4.36,8.36,8.36,0,0,1-3.15,2.31,8.1,8.1,0,0,1-2.55.63A2.5,2.5,0,0,1,356.23,417.42Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "360.34px 413.676px",
        }}
        id="eliaf772uepe"
        className="animable"
      />
      <path
        d="M367.31,421.09s.18,0,.45.11a2,2,0,0,1,.86,1,2.25,2.25,0,0,1,0,1.93,2.23,2.23,0,0,1-4-.45,2.26,2.26,0,0,1,.39-1.89,2,2,0,0,1,1-.74c.3-.08.47,0,.47,0s-.69.13-1.21,1a1.94,1.94,0,0,0-.23,1.55,1.79,1.79,0,0,0,3.1.35,1.92,1.92,0,0,0,.11-1.56C368,421.37,367.26,421.17,367.31,421.09Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "366.697px 423.098px",
        }}
        id="eltco903co36p"
        className="animable"
      />
      <path
        d="M361.07,432a3.25,3.25,0,0,1,1.07-.26,9.78,9.78,0,0,1,3,0,11.49,11.49,0,0,1,6.31,3,10.4,10.4,0,0,1,1,1,2.28,2.28,0,0,1,.39.68,1.1,1.1,0,0,1,0,.9,1.05,1.05,0,0,1-.74.51,2.94,2.94,0,0,1-.78,0l-1.36-.15a24.3,24.3,0,0,1-2.58-.44,10.18,10.18,0,0,1-4-1.82,6.32,6.32,0,0,1-1.89-2.32,2.3,2.3,0,0,1-.31-1.05,7.21,7.21,0,0,0,2.43,3.07,10.16,10.16,0,0,0,3.93,1.65,23.11,23.11,0,0,0,2.53.4l1.35.14c.43.05.89,0,1-.26s-.05-.68-.3-1a12,12,0,0,0-.91-1,11.37,11.37,0,0,0-2-1.53,12.06,12.06,0,0,0-4-1.5A17.35,17.35,0,0,0,361.07,432Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "367.003px 434.74px",
        }}
        id="eln6fspr6kzah"
        className="animable"
      />
      <path
        d="M362.47,445s.19-.11.56-.08a2.5,2.5,0,0,1,1.44.6,2.33,2.33,0,0,1,.81,2.19,2.48,2.48,0,0,1-2,2,2.33,2.33,0,0,1-2.37-1.56,1.87,1.87,0,0,1,0-1.32,2.08,2.08,0,0,1,2.25-1.21c.37.09.52.25.51.27s-.2-.05-.54-.07a2,2,0,0,0-1.28.43,1.51,1.51,0,0,0-.52,1.74,1.88,1.88,0,0,0,1.86,1.2,2,2,0,0,0,1.62-1.58,2,2,0,0,0-.59-1.82A3.38,3.38,0,0,0,362.47,445Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "363.052px 447.315px",
        }}
        id="elcxoyydeur5"
        className="animable"
      />
      <path
        d="M337.94,465.11c0-.1,1.85,0,4.8-.25a18.15,18.15,0,0,0,5-1.09,10.07,10.07,0,0,0,4.85-3.77c.11-.17.21-.35.31-.51l.19.38a16.12,16.12,0,0,0-10.63,2.1,24.62,24.62,0,0,0-3.61,2.8,4.73,4.73,0,0,1,.79-1,13.67,13.67,0,0,1,2.63-2.15,15.93,15.93,0,0,1,10.9-2.31l.38.06-.19.32c-.11.18-.21.37-.33.55a10.38,10.38,0,0,1-5.11,3.94,17.72,17.72,0,0,1-5.18,1c-1.49.08-2.7,0-3.53,0A5.63,5.63,0,0,1,337.94,465.11Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "345.745px 462.175px",
        }}
        id="elkhcu3ndohj"
        className="animable"
      />
      <path
        d="M360.71,456.45s.11-.14.41-.21a1.61,1.61,0,0,1,1.24.32,1.66,1.66,0,0,1,.52,1.83,1.94,1.94,0,0,1-1.88,1.36,2.23,2.23,0,0,1-2-1.22,1.82,1.82,0,0,1,.11-1.9,1.52,1.52,0,0,1,1.12-.62c.31,0,.46.09.45.11s-.17,0-.42.09a1.49,1.49,0,0,0-.85.63,1.46,1.46,0,0,0,0,1.47,1.79,1.79,0,0,0,1.55.92,1.47,1.47,0,0,0,1.42-1,1.26,1.26,0,0,0-.3-1.4,1.57,1.57,0,0,0-1-.4C360.88,456.44,360.73,456.49,360.71,456.45Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "360.878px 457.88px",
        }}
        id="eluy7c2wleac"
        className="animable"
      />
      <path
        d="M173.39,426.41s.05.12.11.35a5.41,5.41,0,0,1,.11,1,7.39,7.39,0,0,1-1,3.66,9.06,9.06,0,0,1-4.17,3.76,13.9,13.9,0,0,1-6.8,1.05c-.3,0-.59-.06-.86-.09l-.36,0,.15-.34a27,27,0,0,1,3.36-5.64,10.7,10.7,0,0,1,4.25-3.25,7.38,7.38,0,0,1,3.53-.59,4.56,4.56,0,0,1,1,.17,1,1,0,0,1,.32.12s-.46-.07-1.29-.09a7.81,7.81,0,0,0-3.38.72,10.71,10.71,0,0,0-4,3.21,28,28,0,0,0-3.26,5.58l-.2-.37.84.08a13.61,13.61,0,0,0,6.56-1,8.81,8.81,0,0,0,4.05-3.5,7.46,7.46,0,0,0,1.1-3.48C173.45,426.91,173.34,426.42,173.39,426.41Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "167.015px 431.296px",
        }}
        id="el2gn9g5h1xyi"
        className="animable"
      />
      <path
        d="M164.86,439.33a3,3,0,0,0-1.79.38,1.88,1.88,0,0,0-.9,1.59,2,2,0,0,0,3.29,1.52,1.9,1.9,0,0,0,.62-1.72,3.07,3.07,0,0,0-.87-1.61s.21,0,.49.25a2.31,2.31,0,0,1,.74,1.3,2.24,2.24,0,0,1-.66,2.14,2.41,2.41,0,0,1-4.09-1.89,2.23,2.23,0,0,1,1.19-1.89,2.3,2.3,0,0,1,1.48-.28C164.71,439.19,164.87,439.31,164.86,439.33Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "164.09px 441.482px",
        }}
        id="elcuq7wfrgy24"
        className="animable"
      />
      <path
        d="M169.51,439.68a13,13,0,0,0,3.11.71A8.92,8.92,0,0,0,176,440a9.06,9.06,0,0,0,1.83-.84,3.51,3.51,0,0,0,1.46-1.39.47.47,0,0,0-.25-.64,3.4,3.4,0,0,0-1-.2,11.41,11.41,0,0,0-2,0,11.19,11.19,0,0,0-3.34.82,22.14,22.14,0,0,0-2.8,1.56s.18-.27.62-.63a9.64,9.64,0,0,1,2-1.27,10.61,10.61,0,0,1,3.44-.95,10,10,0,0,1,2.12,0,3.54,3.54,0,0,1,1.17.24,1,1,0,0,1,.5,1.27,2.34,2.34,0,0,1-.76,1,8.19,8.19,0,0,1-.93.65,8.7,8.7,0,0,1-5.51,1.19,7.41,7.41,0,0,1-2.32-.63C169.75,439.9,169.49,439.71,169.51,439.68Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "174.664px 438.637px",
        }}
        id="elufeqazii9do"
        className="animable"
      />
      <path
        d="M163.44,445s.1.05.26.19a4.54,4.54,0,0,1,.64.66,7.19,7.19,0,0,1,1.4,3.09,10.15,10.15,0,0,1-.31,5,18.16,18.16,0,0,1-1.12,2.76c-.23.46-.48.92-.74,1.38-.14.24-.26.45-.43.71a1.19,1.19,0,0,1-.81.57.71.71,0,0,1-.57-.21,1.35,1.35,0,0,1-.27-.42l-.31-.74c-.2-.49-.39-1-.55-1.48a15,15,0,0,1-.63-2.92,8.43,8.43,0,0,1,.9-4.95,6.28,6.28,0,0,1,2.33-2.47,4.09,4.09,0,0,1,.85-.37,1,1,0,0,1,.32-.07s-.41.18-1.06.61a6.39,6.39,0,0,0-2.11,2.47,8.16,8.16,0,0,0-.75,4.73,14.16,14.16,0,0,0,.64,2.81q.24.72.54,1.44c.19.45.41,1.14.63,1.06s.58-.59.83-1,.51-.9.74-1.35a18.69,18.69,0,0,0,1.11-2.67,10.17,10.17,0,0,0,.41-4.82,7.63,7.63,0,0,0-1.2-3C163.73,445.29,163.4,445,163.44,445Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "162.927px 452.181px",
        }}
        id="el4e0d38hayl9"
        className="animable"
      />
      <path
        d="M168.88,444.46a5.39,5.39,0,0,1,1.25.45,13.32,13.32,0,0,1,3.05,1.92A17.16,17.16,0,0,1,179,457.05l0,.15.12.62-.53-.36a30.17,30.17,0,0,1-8.18-8.43,26.06,26.06,0,0,1-1.73-3.12,5.47,5.47,0,0,1-.49-1.21c.09,0,.84,1.66,2.53,4.13a32.25,32.25,0,0,0,8.17,8.2l-.41.26,0-.16a17.35,17.35,0,0,0-5.55-10A21.21,21.21,0,0,0,168.88,444.46Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "173.655px 451.14px",
        }}
        id="eld36s2ikcbcj"
        className="animable"
      />
      <path
        d="M155.68,452s.23.2.42.69a3.34,3.34,0,0,1,0,2.23,3.6,3.6,0,0,1-2.45,2.2,3.31,3.31,0,0,1-2-.08,3.58,3.58,0,0,1-1.71-1.33,3.3,3.3,0,0,1-.58-2.09,3.4,3.4,0,0,1,.75-1.87,3.09,3.09,0,0,1,3.07-1.15,3.21,3.21,0,0,1,1.88,1.19,1.41,1.41,0,0,1,.34.74s-.16-.25-.5-.61a3.12,3.12,0,0,0-1.79-.95,2.68,2.68,0,0,0-2.62,1.07,2.81,2.81,0,0,0-.12,3.37,3,3,0,0,0,3.17,1.25,3.26,3.26,0,0,0,2.22-1.87,3.4,3.4,0,0,0,.16-2C155.79,452.29,155.64,452,155.68,452Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "152.822px 453.888px",
        }}
        id="elxzd9rtq5ta"
        className="animable"
      />
      <path
        d="M146.32,454.63s0,.12-.15.34a5.27,5.27,0,0,1-.61.89,8.55,8.55,0,0,1-3.15,2.36,10.49,10.49,0,0,1-5.79.78,15.48,15.48,0,0,1-6.62-2.73c-.28-.19-.55-.4-.81-.59l-.24-.18.22-.21a12.72,12.72,0,0,1,6-3.31,12.3,12.3,0,0,1,5.53-.05,12.1,12.1,0,0,1,3.46,1.33,4.84,4.84,0,0,1,1.1.78,16.81,16.81,0,0,0-4.63-1.76,12.4,12.4,0,0,0-5.35.16,12.58,12.58,0,0,0-5.71,3.22l0-.39c.25.18.51.38.79.57a15.35,15.35,0,0,0,6.39,2.68,10.27,10.27,0,0,0,5.57-.64,8.86,8.86,0,0,0,3.15-2.16C146,455.05,146.28,454.6,146.32,454.63Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "137.635px 455.377px",
        }}
        id="elk37k5vw72be"
        className="animable"
      />
      <path
        d="M123.08,457.46s.2-.11.6-.06a2.13,2.13,0,0,1,1.41.88,2.26,2.26,0,0,1,.44,1.11,2,2,0,0,1-.37,1.34,2.47,2.47,0,0,1-2.86.93,2.57,2.57,0,0,1-1.48-2.63,2.35,2.35,0,0,1,1.54-1.92,2.49,2.49,0,0,1,1.66,0c.38.13.53.29.52.31s-.21-.05-.57-.12a2.64,2.64,0,0,0-1.47.19,2,2,0,0,0-1.2,1.63,2.12,2.12,0,0,0,1.19,2.09,2,2,0,0,0,2.28-.71,1.7,1.7,0,0,0,0-2,2.21,2.21,0,0,0-1.15-.9C123.3,457.49,123.08,457.51,123.08,457.46Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "123.17px 459.385px",
        }}
        id="elimie3mt142"
        className="animable"
      />
      <path
        d="M126.29,462a13.29,13.29,0,0,0,2,4.15,10.25,10.25,0,0,0,9.71,4l.35-.05-.18.39a18.31,18.31,0,0,0-8.07-7.09,29.37,29.37,0,0,0-4.29-1.43,4.51,4.51,0,0,1,1.23.13,15.62,15.62,0,0,1,3.21,1,18,18,0,0,1,8.37,7.16l.2.33-.38.06-.36.06a10.68,10.68,0,0,1-6.19-1,10.28,10.28,0,0,1-3.9-3.33,10.43,10.43,0,0,1-1.48-3.12A3.65,3.65,0,0,1,126.29,462Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "132.315px 466.389px",
        }}
        id="el5hzy97q8vjf"
        className="animable"
      />
      <path
        d="M117.56,462.88s.17-.11.51,0a1.65,1.65,0,0,1,1.08.9,1.76,1.76,0,0,1-.43,2,2.14,2.14,0,0,1-1.16.58,2.27,2.27,0,0,1-1.37-.24,2.43,2.43,0,0,1-1.38-2.15,1.46,1.46,0,0,1,.5-1.09,2,2,0,0,1,.91-.43,3,3,0,0,1,1.38.1c.31.09.47.16.46.19s-.18,0-.49,0a3.74,3.74,0,0,0-1.26.06,1.22,1.22,0,0,0-1,1.17,2,2,0,0,0,1.14,1.68,1.7,1.7,0,0,0,2-.23,1.37,1.37,0,0,0,.42-1.54,1.58,1.58,0,0,0-.8-.86C117.74,462.92,117.56,462.92,117.56,462.88Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "117.052px 464.397px",
        }}
        id="el7hcj8bt56pc"
        className="animable"
      />
      <path
        d="M148.37,463.55a7.14,7.14,0,0,1-2.19.36,22.33,22.33,0,0,1-5.35-.26,22.07,22.07,0,0,1-5.14-1.52,6.88,6.88,0,0,1-1.94-1.07,48.36,48.36,0,0,0,7.17,2.08A48.83,48.83,0,0,0,148.37,463.55Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "141.06px 462.514px",
        }}
        id="elu9gugkgchsl"
        className="animable"
      />
      <path
        d="M169.08,464.53c-.14-.07.78-1.79,1.21-4.12s.21-4.25.37-4.27a10.1,10.1,0,0,1-1.58,8.39Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "170.02px 460.335px",
        }}
        id="ell1tsty6hmi"
        className="animable"
      />
      <path
        d="M186.87,444.71a18,18,0,0,1-5.49,1.22,17.47,17.47,0,0,1-5.62-.06c0-.15,2.51-.13,5.57-.46S186.83,444.56,186.87,444.71Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "181.315px 445.406px",
        }}
        id="elgwcbvl1omws"
        className="animable"
      />
      <path
        d="M186.2,430.09a24,24,0,0,0-5.44.36,24.75,24.75,0,0,0-5.06,2.05,11.13,11.13,0,0,1,10.5-2.41Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "180.95px 431.079px",
        }}
        id="elvhb8u125f9e"
        className="animable"
      />
      <path
        d="M187.64,437.26a13.11,13.11,0,0,0,3.35.95,8.36,8.36,0,0,0,3.69-.43,8.53,8.53,0,0,0,3.7-2.57h0l.07.39a8.94,8.94,0,0,0-4.36-1.2,9.58,9.58,0,0,0-3.67.63,13.82,13.82,0,0,0-3,1.76,2.49,2.49,0,0,1,.64-.71,8.39,8.39,0,0,1,2.23-1.39,9.53,9.53,0,0,1,3.82-.77,9.24,9.24,0,0,1,4.62,1.23l.27.16-.2.23h0a8.78,8.78,0,0,1-3.95,2.7,8.49,8.49,0,0,1-3.88.34,8.33,8.33,0,0,1-2.51-.79A2.83,2.83,0,0,1,187.64,437.26Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "193.21px 436.294px",
        }}
        id="elh36glkfg4hg"
        className="animable"
      />
      <path
        d="M195.2,446.15s.17.07.33.33a2,2,0,0,1,.23,1.26,2.23,2.23,0,0,1-1,1.63,2.23,2.23,0,0,1-3.17-2.45,2.25,2.25,0,0,1,1.31-1.41,2,2,0,0,1,1.28-.09c.3.09.42.21.41.23a2.68,2.68,0,0,0-1.53.2,1.89,1.89,0,0,0-1,1.2,1.68,1.68,0,0,0,.68,1.67,1.64,1.64,0,0,0,1.79.23,1.93,1.93,0,0,0,.91-1.27A2.66,2.66,0,0,0,195.2,446.15Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "193.663px 447.477px",
        }}
        id="elzhged2xo42b"
        className="animable"
      />
      <path
        d="M184.2,452.25a3.08,3.08,0,0,1,1,.33,10,10,0,0,1,2.54,1.56,11.81,11.81,0,0,1,2.84,3.41,11.36,11.36,0,0,1,1.28,3.82,2.93,2.93,0,0,1,0,.78,1.11,1.11,0,0,1-.5.75,1,1,0,0,1-.91.05,2.74,2.74,0,0,1-.67-.39l-1.08-.84a24.13,24.13,0,0,1-2-1.71,10,10,0,0,1-2.51-3.66,6.51,6.51,0,0,1-.42-3,2.66,2.66,0,0,1,.28-1.06,7.37,7.37,0,0,0,.48,3.89,10.33,10.33,0,0,0,2.5,3.45c.59.56,1.25,1.1,2,1.65l1.08.83c.35.26.76.46,1,.3s.31-.61.26-1a11.5,11.5,0,0,0-.26-1.3,11.73,11.73,0,0,0-.92-2.35,12.22,12.22,0,0,0-2.66-3.36A17.3,17.3,0,0,0,184.2,452.25Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "187.813px 457.643px",
        }}
        id="el96270h8e94h"
        className="animable"
      />
      <path
        d="M178.67,464s.21,0,.52.22a2.49,2.49,0,0,1,.91,1.26,2.31,2.31,0,0,1-.44,2.29,2.47,2.47,0,0,1-2.77.66,2.33,2.33,0,0,1-1.22-2.57,1.89,1.89,0,0,1,.71-1.11,2,2,0,0,1,1.07-.36,2,2,0,0,1,1.49.5c.26.27.31.49.29.5s-.15-.15-.42-.34a1.94,1.94,0,0,0-1.32-.3,1.51,1.51,0,0,0-1.35,1.21,1.88,1.88,0,0,0,1,2,2,2,0,0,0,2.2-.51,2,2,0,0,0,.44-1.86A3.37,3.37,0,0,0,178.67,464Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "177.924px 466.303px",
        }}
        id="eld51ftx1m9v7"
        className="animable"
      />
      <path
        d="M147.23,468.51c.05-.09,1.6.93,4.24,2.28a18.16,18.16,0,0,0,4.86,1.68,10.12,10.12,0,0,0,6.1-.7l.53-.29,0,.42a16.18,16.18,0,0,0-10.17-3.72,24.06,24.06,0,0,0-4.54.52,4.7,4.7,0,0,1,1.17-.42,14.64,14.64,0,0,1,3.37-.46,15.9,15.9,0,0,1,10.51,3.69l.29.24-.33.18c-.18.1-.36.21-.56.3a10.35,10.35,0,0,1-6.41.71,17.26,17.26,0,0,1-4.95-1.83c-1.32-.71-2.33-1.37-3-1.83A7.42,7.42,0,0,1,147.23,468.51Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "155.41px 470.488px",
        }}
        id="elvjl9q03nto"
        className="animable"
      />
      <path
        d="M171.19,472.94s.17-.07.47,0a1.58,1.58,0,0,1,.88.92,1.62,1.62,0,0,1-.5,1.83,1.92,1.92,0,0,1-2.31.18,2.22,2.22,0,0,1-1.06-2.06,1.82,1.82,0,0,1,1.08-1.57,1.51,1.51,0,0,1,1.28.05c.27.15.34.31.32.33s-.15-.07-.4-.14a1.42,1.42,0,0,0-1,.09,1.48,1.48,0,0,0-.75,1.27,1.79,1.79,0,0,0,.85,1.59,1.47,1.47,0,0,0,1.73-.11,1.23,1.23,0,0,0,.46-1.34,1.53,1.53,0,0,0-.62-.86C171.34,473,171.19,473,171.19,472.94Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "170.654px 474.147px",
        }}
        id="el1vu0w4un1se"
        className="animable"
      />
      <path
        d="M271.38,277.74a24.87,24.87,0,0,0,4.29-4.15,19,19,0,0,0,3-5.67,18.32,18.32,0,0,0,.89-7.78V260l.39.19a17.44,17.44,0,0,0-5.45,5.55,18.35,18.35,0,0,0-2.37,5.94,22.83,22.83,0,0,0-.3,5.92,1.32,1.32,0,0,1-.1-.41,10.16,10.16,0,0,1-.17-1.18,16.28,16.28,0,0,1,.21-4.4,18,18,0,0,1,2.32-6.12,17.43,17.43,0,0,1,5.59-5.74l.36-.23,0,.42v.11a18.42,18.42,0,0,1-.95,8,18.9,18.9,0,0,1-3.2,5.75,17,17,0,0,1-3.2,3.06,11,11,0,0,1-1,.66A1.37,1.37,0,0,1,271.38,277.74Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "275.758px 268.63px",
        }}
        id="eld2zfdzior9n"
        className="animable"
      />
      <path
        d="M277.36,252.27s.2-.1.59-.05a2.46,2.46,0,0,1,1.42.77,2.38,2.38,0,0,1,.56,2.35,2.69,2.69,0,0,1-2.3,1.85,2.66,2.66,0,0,1-2.49-1.58,2.36,2.36,0,0,1,.28-2.39,2.43,2.43,0,0,1,1.33-.93c.37-.09.59,0,.59,0a3.08,3.08,0,0,0-1.62,1.16,2,2,0,0,0-.15,2,2.08,2.08,0,0,0,3.9-.22,2,2,0,0,0-.38-2A3,3,0,0,0,277.36,252.27Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "277.486px 254.698px",
        }}
        id="elripb95q7a8s"
        className="animable"
      />
      <path
        d="M301.16,237.42a4.13,4.13,0,0,1-.77.7,18,18,0,0,1-2.33,1.62,64.46,64.46,0,0,1-8.42,4c-1.67.72-3.24,1.43-4.64,2.14a28.76,28.76,0,0,0-3.54,2.17c-1.91,1.39-2.87,2.53-2.95,2.45a4,4,0,0,1,.64-.82,7.7,7.7,0,0,1,.86-.87,12.77,12.77,0,0,1,1.23-1.06,25.34,25.34,0,0,1,3.54-2.29c1.4-.75,3-1.48,4.65-2.2a88.75,88.75,0,0,0,8.45-3.85C300,238.27,301.1,237.34,301.16,237.42Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "289.835px 243.96px",
        }}
        id="el8mlocdscs6n"
        className="animable"
      />
      <path
        d="M286.52,248.48s.12-.06.36-.11a9.55,9.55,0,0,1,1.09-.15,16.48,16.48,0,0,1,4,.21,57.46,57.46,0,0,1,5.82,1.28,10.28,10.28,0,0,1,3.23,1.54,5.82,5.82,0,0,1,2.26,3.15l.07.29-.29,0-.42.05a20.67,20.67,0,0,1-13.08-3,18.79,18.79,0,0,1-3.25-2.53,11.06,11.06,0,0,1-.76-.82,1.23,1.23,0,0,1-.24-.31,31,31,0,0,0,4.44,3.34,20.94,20.94,0,0,0,12.83,2.78l.41,0-.22.32a5.41,5.41,0,0,0-2-2.88,10,10,0,0,0-3.07-1.48c-2.13-.61-4.1-1.06-5.74-1.39a19.48,19.48,0,0,0-3.94-.36C287,248.44,286.53,248.52,286.52,248.48Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "294.33px 251.467px",
        }}
        id="elf5slpwz6knf"
        className="animable"
      />
      <path
        d="M298.8,241.94s.07-.16.35-.27a1.41,1.41,0,0,1,1.2.22,1.63,1.63,0,0,1,.56.69,1.64,1.64,0,0,1,0,1,2.2,2.2,0,0,1-1.63,1.5,3.36,3.36,0,0,1-2.37-.45l-.1-.06v-.09a2.12,2.12,0,0,1,.84-2.11c.47-.33.82-.3.82-.26s-.29.13-.64.48a1.92,1.92,0,0,0-.57,1.78l-.11-.15a3.07,3.07,0,0,0,2,.35,1.79,1.79,0,0,0,1.3-1.13,1.14,1.14,0,0,0-.35-1.28,1.31,1.31,0,0,0-.93-.32C299,241.9,298.82,242,298.8,241.94Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "298.881px 243.377px",
        }}
        id="eln50znd8gxx"
        className="animable"
      />
      <path
        d="M295.38,238.5a23.19,23.19,0,0,0,4.81-3.41,18.29,18.29,0,0,0,3.72-5.15,17.48,17.48,0,0,0,1.79-7.53l.39.23h0A23.08,23.08,0,0,0,296.63,233a32.86,32.86,0,0,0-1.86,5.63,1.24,1.24,0,0,1,0-.42A11.38,11.38,0,0,1,295,237a19.92,19.92,0,0,1,1.31-4.18,22.62,22.62,0,0,1,9.52-10.66h0l.39-.24v.46a17.44,17.44,0,0,1-1.88,7.74,18,18,0,0,1-3.9,5.2,16,16,0,0,1-3.58,2.53,10.19,10.19,0,0,1-1.09.49C295.52,238.47,295.38,238.52,295.38,238.5Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "300.486px 230.275px",
        }}
        id="elynpvgxvolzl"
        className="animable"
      />
      <path
        d="M310.43,225.22a7.58,7.58,0,0,1-1.35,3.49,7.35,7.35,0,0,1-2.51,2.76c-.11-.11,1-1.32,2.07-3S310.28,225.18,310.43,225.22Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "308.496px 228.345px",
        }}
        id="eld4gdev0qqd"
        className="animable"
      />
      <path
        d="M286.21,242a24.51,24.51,0,0,0,2.35-2.76,12.64,12.64,0,0,0,2.1-8.25l.44.16-.07.07a16,16,0,0,0-4.4,7.48c-.58,2.19-.53,3.62-.64,3.62a3.33,3.33,0,0,1-.06-1,13.79,13.79,0,0,1,.34-2.71,15.47,15.47,0,0,1,4.4-7.77l.07-.07.38-.37.06.53a12.41,12.41,0,0,1-2.32,8.52,10.58,10.58,0,0,1-1.84,2A3.44,3.44,0,0,1,286.21,242Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "288.578px 236.36px",
        }}
        id="elft1g5j1bkkw"
        className="animable"
      />
      <path
        d="M309.19,232.33s0-.18.25-.29a.89.89,0,0,1,1,.35,1.36,1.36,0,0,1-.15,1.52,3.11,3.11,0,0,1-1.37,1.19,1.17,1.17,0,0,1-1.07-.12,1.06,1.06,0,0,1-.43-.9,1.49,1.49,0,0,1,.78-1.3c.74-.41,1.24-.4,1.26-.35s-.46.23-1.05.65a1.17,1.17,0,0,0-.51,1,.58.58,0,0,0,.84.54c.91-.41,1.7-1.5,1.4-2a.72.72,0,0,0-.63-.36C309.31,232.25,309.22,232.36,309.19,232.33Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "309.012px 233.589px",
        }}
        id="eloudd91g39rm"
        className="animable"
      />
      <path
        d="M313.22,204.63a4.62,4.62,0,0,1-.07-1.23,29.56,29.56,0,0,1,.18-3.38,38.82,38.82,0,0,1,.84-5c.22-.92.48-1.87.79-2.86.15-.49.32-1,.5-1.48a1.42,1.42,0,0,1,.54-.79.71.71,0,0,1,.59-.09.84.84,0,0,1,.46.36,2.88,2.88,0,0,1,.22,1.72c0,.53-.07,1.06-.13,1.57a28.71,28.71,0,0,1-.46,2.94,30.2,30.2,0,0,1-1.41,4.82,24.28,24.28,0,0,1-1.41,3.07,5.5,5.5,0,0,1-.65,1.06c-.09,0,.78-1.59,1.72-4.26a33.33,33.33,0,0,0,1.28-4.79,27.49,27.49,0,0,0,.42-2.89c.06-.51.1-1,.12-1.55a2.47,2.47,0,0,0-.14-1.41c-.18-.32-.51-.09-.66.41s-.35,1-.51,1.47q-.46,1.45-.81,2.82a48.68,48.68,0,0,0-.94,4.87c-.19,1.41-.28,2.55-.34,3.34A6.25,6.25,0,0,1,313.22,204.63Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "315.226px 197.556px",
        }}
        id="elty9fjicx8gq"
        className="animable"
      />
      <path
        d="M283.44,176.83a2.9,2.9,0,0,1-.8-.49,25.35,25.35,0,0,1-2-1.62,30.35,30.35,0,0,1-5.43-6.58l-.2-.34.37-.05a4.44,4.44,0,0,1,.65-.08,6.22,6.22,0,0,1,4.59,1.89,10.21,10.21,0,0,1,2.19,3.43,20.66,20.66,0,0,1,.83,2.58,4,4,0,0,1,.2,1c-.1,0-.47-1.34-1.37-3.41a10.18,10.18,0,0,0-2.18-3.23,5.8,5.8,0,0,0-4.23-1.72,3.42,3.42,0,0,0-.57.07l.17-.39a33.76,33.76,0,0,0,5.23,6.58C282.44,176,283.49,176.77,283.44,176.83Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "279.425px 172.249px",
        }}
        id="elvsmqul2tn1"
        className="animable"
      />
      <path
        d="M286,173.29c.05.08-.63.26-.92,1.17a1.81,1.81,0,0,0,.16,1.49,1.65,1.65,0,0,0,2.86-.65,1.8,1.8,0,0,0-.49-1.41,2.51,2.51,0,0,0-1.33-.66s.14-.11.44-.1a1.85,1.85,0,0,1,1.15.5,2.09,2.09,0,0,1,.71,1.73,2.09,2.09,0,0,1-3.75.84,2.11,2.11,0,0,1-.1-1.87,1.87,1.87,0,0,1,.83-.94C285.78,173.26,286,173.27,286,173.29Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "286.572px 175.098px",
        }}
        id="elx2xa351v8y"
        className="animable"
      />
      <path
        d="M286.32,167.71c.11.11-.69,1-1.24,2.25s-.66,2.45-.81,2.45a3.62,3.62,0,0,1,.33-2.66C285.21,168.35,286.25,167.6,286.32,167.71Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "285.241px 170.055px",
        }}
        id="eltwe5yuqdd99"
        className="animable"
      />
      <path
        d="M287.54,171.75a7.17,7.17,0,0,0,1.69-.14,3.58,3.58,0,0,0,2.57-2.75l.24.29H292a5.32,5.32,0,0,0-3.73,1.43c-.78.73-1.05,1.37-1.14,1.33a2.85,2.85,0,0,1,.88-1.58,5.23,5.23,0,0,1,4-1.7h.35l-.05.29a3.55,3.55,0,0,1-1.21,2.15,3.8,3.8,0,0,1-1.78.88A2.25,2.25,0,0,1,287.54,171.75Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "289.745px 170.338px",
        }}
        id="ela16jfzfqte"
        className="animable"
      />
      <path
        d="M291.8,174.35c-.09.12-.72-.27-1.58-.45s-1.58-.1-1.62-.24.74-.49,1.73-.26S291.9,174.26,291.8,174.35Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "290.205px 173.848px",
        }}
        id="elpsqzt42qbz"
        className="animable"
      />
      <path
        d="M285.85,178.06s.21.12.5.44a5.07,5.07,0,0,1,.9,1.57,6.11,6.11,0,0,1,.37,2.67,5.91,5.91,0,0,1-1.14,3.11l-.27.34-.2.25-.2-.26a6.11,6.11,0,0,1-1-5.47,5,5,0,0,1,.74-1.54c.24-.33.4-.48.42-.46a14.34,14.34,0,0,0-.81,2.09,6,6,0,0,0,1.09,5.06h-.39l.24-.31a6.1,6.1,0,0,0,.84-5.36A10.81,10.81,0,0,0,285.85,178.06Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "286.097px 182.25px",
        }}
        id="elhhvat2pwpe7"
        className="animable"
      />
      <path
        d="M290.67,180.59c-.14,0-.17-.88-.81-1.68s-1.44-1.07-1.41-1.21.25-.1.62,0a2.59,2.59,0,0,1,1.21.88,2.5,2.5,0,0,1,.53,1.39C290.83,180.37,290.74,180.6,290.67,180.59Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "289.631px 179.1px",
        }}
        id="elx2souhhybp"
        className="animable"
      />
      <path
        d="M283.07,190.69c-.09,0,.11-1.11.17-2.89a21.68,21.68,0,0,0-.81-6.84,17.69,17.69,0,0,0-1.47-3.49,14.56,14.56,0,0,0-1.79-2.51c-1.18-1.32-2.11-2-2.05-2s.26.11.68.39a10.18,10.18,0,0,1,1.64,1.38,13.69,13.69,0,0,1,1.94,2.53,17.24,17.24,0,0,1,1.55,3.58,19.41,19.41,0,0,1,.68,7,15.19,15.19,0,0,1-.31,2.12A2.11,2.11,0,0,1,283.07,190.69Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "280.399px 181.825px",
        }}
        id="eloglouiclbdc"
        className="animable"
      />
      <path
        d="M265.93,170.27s-4.75,1.75-4.95,12.8c-.21,12.14-3.06,48.34,5.18,53.44,10.16,6.28,45.72-19.61,45.72-19.61V204l-30.34,10.83,1.17-25C283,189.67,284.39,168.76,265.93,170.27Z"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "286.108px 203.842px",
        }}
        id="el1xyb3zuc0jr"
        className="animable"
      />
      <path
        d="M337.26,216.65a1.52,1.52,0,0,1-.41,2.52h0a1.54,1.54,0,0,1-1.63-.25l-1.3-1.23.07,0a1.59,1.59,0,0,1-.52,2.53h0c-.63.37-1.69-.19-2.15-.55h0a3,3,0,0,1-3.07.32l-5.85-3.42-12,.35,1.46-13,15.25.36c.63.07.78.17,1.85.38l11,2.15a3,3,0,0,1-2.58,1.59c-1.38.24-8.26-.06-8.26-.06l8.11,8.28"
        style={{
          fill: "rgb(255, 190, 157)",
          transformOrigin: "325.18px 212.131px",
        }}
        id="ela8qcd8j6eth"
        className="animable"
      />
      <path
        d="M322.4,213.38a1.09,1.09,0,0,1,.44,0l.51,0a2.73,2.73,0,0,1,.7.11,2.23,2.23,0,0,1,.75.41l.74.6,1.67,1.38c1.18,1,2.24,1.9,3,2.57a9.72,9.72,0,0,1,1.19,1.13,9.28,9.28,0,0,1-1.32-1c-.79-.62-1.87-1.51-3.05-2.5l-1.66-1.4-.72-.62a2.33,2.33,0,0,0-.67-.4,2.74,2.74,0,0,0-.64-.14l-.51-.08A2.05,2.05,0,0,1,322.4,213.38Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "326.9px 216.469px",
        }}
        id="elvz4sdgg1ex"
        className="animable"
      />
      <path
        d="M334.18,217.85s-.16-.11-.43-.35l-1.12-1c-.94-.87-2.23-2.08-3.72-3.36a17.19,17.19,0,0,0-4.06-2.85,3.84,3.84,0,0,0-1.44-.35c-.35,0-.55,0-.55,0s0,0,.13-.06a2.08,2.08,0,0,1,.42-.08,3.73,3.73,0,0,1,1.52.27,16,16,0,0,1,4.17,2.82c1.49,1.29,2.77,2.53,3.67,3.44.46.46.82.83,1.06,1.1S334.2,217.84,334.18,217.85Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "328.521px 213.824px",
        }}
        id="el4a4m8hfrhss"
        className="animable"
      />
      <path
        d="M337.4,216.79a3.32,3.32,0,0,1-.49-.38l-1.26-1.09c-1.06-.93-2.52-2.24-4.11-3.69l-4.05-3.73a2.56,2.56,0,0,0-1.45-.68,3.34,3.34,0,0,0-.6,0s0,0,.14-.07a1.27,1.27,0,0,1,.46-.08,2.62,2.62,0,0,1,1.57.64c1.09.92,2.52,2.23,4.12,3.68s3,2.78,4,3.75l1.21,1.16C337.27,216.61,337.42,216.77,337.4,216.79Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "331.421px 211.93px",
        }}
        id="elv383mlwqm4"
        className="animable"
      />
      <path
        d="M318.08,216.55a13.79,13.79,0,0,1-3.78.61,14.22,14.22,0,0,1-3.82.08,28.59,28.59,0,0,1,7.6-.69Z"
        style={{
          fill: "rgb(235, 153, 110)",
          transformOrigin: "314.28px 216.928px",
        }}
        id="elvssoeodtndh"
        className="animable"
      />
      <path
        d="M329.43,208.27s-.27.08-.54-.21a1.63,1.63,0,0,1-.24-1.36,3.07,3.07,0,0,1,.4-1.32c.19-.3.39-.42.4-.4s-.13.17-.28.48a4.06,4.06,0,0,0-.31,1.27A1.66,1.66,0,0,0,329,208,1,1,0,0,0,329.43,208.27Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "329.022px 206.629px",
        }}
        id="ellsthx5ozuq"
        className="animable"
      />
      <path
        d="M329,205.67a.77.77,0,0,0,.89,0,.91.91,0,0,0,.39-.82,1.15,1.15,0,0,0-1.77-.83.88.88,0,0,0-.18,1.23,1.6,1.6,0,0,0,1.31.36"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "329.22px 204.823px",
        }}
        id="elvzt2r11a0za"
        className="animable"
      />
      <path
        d="M377.47,222.73l-6.09-1.13s-11-3.41-12.83-3a2.7,2.7,0,0,0,1.46,3c1.95,1.14,4.88,2.47,4.88,2.47l-4.26,5.08a3,3,0,0,1-2.22,1.07l-14.3.3a3.51,3.51,0,0,0,2.08,2.21c1.51.4,12,3.28,12,3.28l19.16-.65Z"
        style={{
          fill: "rgb(183, 136, 118)",
          transformOrigin: "360.79px 227.288px",
        }}
        id="el6heng123bbi"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default WeddingWebsiteSVG;
